/* =====================================================================
   nt-fx-rastreio.js: pagina "rastreie seu pedido" (sections/nt-fx-rastreio.liquid)
     busca pelo codigo (ou pelo numero do pedido + e-mail) no servico de rastreio da loja, que conversa com a
     envia.com do lado do servidor e devolve so cidade, uf, coordenadas do centro da cidade, status, eventos e
     previsao. nada de nome, rua ou cep do cliente chega aqui.
     sem endereco do servico (ou com ?demo=1, ?demo=criado|postado|transito|saiu|entregue|problema|cancelado) a pagina
     mostra um pedido de exemplo.
     o mapa 3d (maplibre + three.js, das cdns) so baixa quando o mapa aparece na tela; sem webgl, sem rede ou com
     economia de dados fica o desenho da rota em svg, que tambem e o que aparece enquanto o mapa carrega.
   ===================================================================== */
(() => {
  'use strict';

  const ML = 'https://unpkg.com/maplibre-gl@6.13.0/dist/';
  const THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/0.186.1/three.module.min.js';
  const ESTILO = 'https://tiles.openfreemap.org/styles/dark';
  const TZ = 'America/Sao_Paulo';
  const HORA = 3600e3;
  const DIA = 24 * HORA;
  // contorno do brasil (natural earth, dominio publico), lng,lat com uma casa
  const BRASIL = '-57.6,-30.2 -56.3,-28.9 -55.2,-27.9 -54.5,-27.5 -53.6,-26.9 -53.6,-26.1 -54.1,-25.5 -54.6,-25.7 -54.4,-25.2 -54.3,-24.6 -54.3,-24 -54.7,-23.8 -55,-24 -55.4,-24 -55.5,-23.6 -55.6,-22.7 -55.8,-22.4 -56.5,-22.1 -56.9,-22.3 -57.9,-22.1 -57.9,-20.7 -58.2,-20.2 -57.9,-20 -57.9,-19.4 -57.7,-19 -57.5,-18.2 -57.7,-17.6 -58.3,-17.3 -58.4,-16.9 -58.2,-16.3 -60.2,-16.3 -60.5,-15.1 -60.3,-15.1 -60.3,-14.6 -60.5,-14.4 -60.5,-13.8 -61.1,-13.5 -61.7,-13.5 -62.1,-13.2 -62.8,-13 -63.2,-12.6 -64.3,-12.5 -65.4,-11.6 -65.3,-10.9 -65.4,-10.5 -65.3,-9.8 -66.6,-9.9 -67.2,-10.3 -68,-10.7 -68.3,-11 -68.8,-11 -69.5,-11 -70.1,-11.1 -70.5,-11 -70.5,-9.5 -71.3,-10.1 -72.2,-10.1 -72.6,-9.5 -73.2,-9.5 -73,-9 -73.6,-8.4 -74,-7.5 -73.7,-7.3 -73.7,-6.9 -73.1,-6.6 -73.2,-6.1 -73,-5.7 -72.9,-5.3 -71.7,-4.6 -70.9,-4.4 -70.8,-4.3 -69.9,-4.3 -69.4,-1.6 -69.4,-1.1 -69.6,-0.5 -70,-0.2 -70,0.5 -69.5,0.7 -69.3,0.6 -69.2,1 -69.8,1.1 -69.8,1.7 -67.9,1.7 -67.5,2 -67.3,1.7 -67.1,1.1 -66.9,1.3 -66.3,0.7 -65.5,0.8 -65.4,1.1 -64.6,1.3 -64.2,1.5 -64.1,1.9 -63.4,2.2 -63.4,2.4 -64.3,2.5 -64.4,3.1 -64.4,3.8 -64.8,4.1 -64.6,4.1 -63.9,4 -63.1,3.8 -62.8,4 -62.1,4.2 -61,4.5 -60.6,4.9 -60.7,5.2 -60.2,5.2 -60,5 -60.1,4.6 -59.8,4.4 -59.5,4 -59.8,3.6 -60,2.8 -59.7,2.2 -59.6,1.8 -59,1.3 -58.5,1.3 -58.4,1.5 -58.1,1.5 -57.7,1.7 -57.3,1.9 -56.8,1.9 -56.5,1.9 -56,1.8 -55.9,2 -56.1,2.2 -56,2.5 -55.6,2.4 -55.1,2.5 -54.5,2.3 -54.1,2.1 -53.8,2.4 -53.6,2.3 -53.4,2.1 -52.9,2.1 -52.6,2.5 -52.2,3.2 -51.7,4.2 -51.3,4.2 -51.1,3.7 -50.5,1.9 -50,1.7 -49.9,1 -50.7,0.2 -50.4,-0.1 -48.6,-0.2 -48.6,-1.2 -47.8,-0.6 -46.6,-0.9 -44.9,-1.6 -44.4,-2.1 -44.6,-2.7 -43.4,-2.4 -41.5,-2.9 -40,-2.9 -38.5,-3.7 -37.2,-4.8 -36.5,-5.1 -35.6,-5.1 -35.2,-5.5 -34.9,-6.7 -34.7,-7.3 -35.1,-9 -35.6,-9.6 -37,-11 -37.7,-12.2 -38.4,-13 -38.7,-13.1 -39,-13.8 -38.9,-15.7 -39.2,-17.2 -39.3,-17.9 -39.6,-18.3 -39.8,-19.6 -40.8,-20.9 -40.9,-21.9 -41.8,-22.4 -42,-23 -43.1,-23 -44.6,-23.4 -45.4,-23.8 -46.5,-24.1 -47.6,-24.9 -48.5,-25.9 -48.6,-26.6 -48.5,-27.2 -48.7,-28.2 -48.9,-28.7 -49.6,-29.2 -50.7,-31 -51.6,-31.8 -52.3,-32.2 -52.7,-33.2 -53.4,-33.8 -53.7,-33.2 -53.2,-32.7 -53.8,-32 -54.6,-31.5 -55.6,-30.9 -56,-30.9 -57,-30.1 -57.6,-30.2';

  /* ---------- utilidades ---------- */
  const reduz = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const semAcento = (t) => String(t == null ? '' : t).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const num = (v) => {
    if (v == null || v === '') return null;
    const n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };
  const el = (tag, cls, txt) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  };
  const svgUso = (id, extra) => `<svg aria-hidden="true" focusable="false" ${extra || ''}><use href="#${id}"/></svg>`;
  const espera = (ms) => new Promise((ok) => setTimeout(ok, ms));
  const comTempo = (p, ms) => Promise.race([p, new Promise((_, nao) => setTimeout(() => nao(new Error('tempo')), ms))]);
  const suave = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  /* ---------- datas (a envia manda sem fuso: e horario de brasilia) ---------- */
  function data(v) {
    if (v == null || v === '') return null;
    if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
    if (typeof v === 'number') return new Date(v);
    let t = String(v).trim();
    const br = t.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (br) t = `${br[3]}-${br[2]}-${br[1]}T${br[4] || '12'}:${br[5] || '00'}:${br[6] || '00'}-03:00`;
    else if (/^\d{4}-\d{2}-\d{2}$/.test(t)) t += 'T12:00:00-03:00';
    else if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(t)) t = t.replace(' ', 'T') + '-03:00';
    const d = new Date(t);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const fmt = (o) => new Intl.DateTimeFormat('pt-BR', Object.assign({ timeZone: TZ }, o));
  const F = {
    dia: fmt({ day: 'numeric' }),
    mes: fmt({ month: 'short' }),
    mesLongo: fmt({ month: 'long' }),
    sem: fmt({ weekday: 'short' }),
    semLonga: fmt({ weekday: 'long' }),
    hora: fmt({ hour: '2-digit', minute: '2-digit' }),
    ymd: fmt({ year: 'numeric', month: '2-digit', day: '2-digit' }),
  };
  const limpo = (t) => t.replace(/\./g, '').trim();
  const diaMes = (d) => `${F.dia.format(d)} ${limpo(F.mes.format(d))}`;
  // numero do dia no calendario de brasilia, para contar "faltam n dias"
  const diaSP = (d) => {
    const [dd, mm, aa] = F.ymd.format(d).split('/').map(Number);
    return Math.round(Date.UTC(aa, mm - 1, dd) / DIA);
  };
  function quando(d) {
    if (!d) return '';
    const min = Math.round((Date.now() - d.getTime()) / 60000);
    if (min < 1) return 'agora mesmo';
    if (min < 60) return `há ${min} min`;
    const dif = diaSP(new Date()) - diaSP(d);
    if (dif === 0) return `hoje, ${F.hora.format(d)}`;
    if (dif === 1) return `ontem, ${F.hora.format(d)}`;
    return `${diaMes(d)}, ${F.hora.format(d)}`;
  }

  /* ---------- etapas ---------- */
  const PASSO = { criado: 0, postado: 1, transito: 2, saiu: 3, retirada: 3, entregue: 4 };
  const POSICAO = { criado: 0.015, postado: 0.04, transito: 0.5, saiu: 0.95, retirada: 0.97, entregue: 1 };
  const ROTULO = {
    criado: 'Etiqueta criada',
    postado: 'Postado',
    transito: 'Em trânsito',
    saiu: 'Saiu para entrega',
    retirada: 'Pronto para retirar',
    entregue: 'Entregue',
    problema: 'Atenção na entrega',
    cancelado: 'Cancelado',
    sem_info: 'Sem notícias',
  };
  // catalogo de status da envia (id > etapa), igual ao do servico: aguardando coleta (16) e coleta nao realizada (25)
  // ainda nao foram postados; tentativa de entrega sem sucesso (17, 18, 19, 28) e problema; entregue em parte (27)
  // ainda nao terminou
  const POR_ID = {};
  [[1, 7, 16, 25, 31], [8], [2, 5, 15, 23, 26, 29, 38], [9, 27], [3], [12], [10, 11, 13, 14, 17, 18, 19, 20, 21, 22, 24, 28, 30, 32], [4], [6]].forEach((ids, i) => {
    const nome = ['criado', 'postado', 'transito', 'saiu', 'entregue', 'retirada', 'problema', 'cancelado', 'sem_info'][i];
    ids.forEach((id) => { POR_ID[id] = nome; });
  });
  function etapaDe(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'number') return POR_ID[v] || null;
    const t = semAcento(v).replace(/[_]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!t) return null;
    if (/^\d+$/.test(t)) return POR_ID[+t] || null;
    const id = t.match(/status\.(\d+)/);
    if (id) return POR_ID[+id[1]] || null;
    const curta = { criado: 'criado', postado: 'postado', transito: 'transito', 'em transito': 'transito', saiu: 'saiu', 'saiu para entrega': 'saiu', retirada: 'retirada', entregue: 'entregue', problema: 'problema', cancelado: 'cancelado', desconhecido: 'sem_info' };
    if (curta[t]) return curta[t];
    if (/^(sem info|sem informacao|no info|n\/a|na|none)$/.test(t)) return 'sem_info';
    if (/cancel/.test(t)) return 'cancelado';
    if (/nao entregue|devolv|remetente|extravi|avari|roubad|recusad|endereco (incorreto|insuficiente|errado)|problema|\blost\b|damaged|returned|undeliverable|rejected|misrouted|address error|dead freight|non serviceable/.test(t)) return 'problema';
    if (/saiu para (a )?entrega|out for delivery|rota de entrega|tentativa|attempt/.test(t)) return 'saiu';
    if (/retirada|retirar|pickup at office|ready for pickup/.test(t)) return 'retirada';
    if (/entregue|delivered/.test(t)) return 'entregue';
    if (/postad|coletad|picked up|out for pickup|recebido pel[ao] (transportadora|correios)|^coleta/.test(t)) return 'postado';
    if (/transit|transfer|tratamento|encaminhad|unidade|centro de distribuicao|chegou|shipped|redirect|despach|atras|delay|customs|alfandega|fiscaliza/.test(t)) return 'transito';
    if (/criad|created|etiqueta|label|pendente|pending|assigned|aguardando postagem|informa/.test(t)) return 'criado';
    return null;
  }

  /* ---------- lugares ---------- */
  const MIUDAS = new Set(['de', 'da', 'do', 'das', 'dos', 'e']);
  function capitaliza(t) {
    return t.toLowerCase().split(/(\s+|-|\/)/).map((p, i) => {
      if (!p.trim() || p === '-' || p === '/') return p;
      if (i > 0 && MIUDAS.has(p)) return p;
      if (/^d'/.test(p)) return "d'" + p.charAt(2).toUpperCase() + p.slice(3);
      return p.charAt(0).toUpperCase() + p.slice(1);
    }).join('');
  }
  // "CURITIBA - PR", "Curitiba/PR", "CTE CAMPINAS - VALINHOS/SP" viram "Curitiba, PR"
  function limpaLocal(t) {
    let s = String(t || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    let uf = '';
    const m = s.match(/^(.*?)[\s,/-]+([A-Za-z]{2})$/);
    if (m && /^[A-Z]{2}$/.test(m[2].toUpperCase())) { s = m[1].trim(); uf = m[2].toUpperCase(); }
    if (s === s.toUpperCase()) s = capitaliza(s);
    return uf ? `${s}, ${uf}` : s;
  }
  function lugar(o) {
    if (!o || typeof o !== 'object') return null;
    const lat = num(o.lat != null ? o.lat : o.latitude);
    const lng = num(o.lng != null ? o.lng : o.lon != null ? o.lon : o.longitude);
    const cidade = o.cidade || o.city || '';
    const uf = String(o.uf || o.state || '').toUpperCase();
    if (!cidade && lat == null) return null;
    return { cidade: cidade && cidade === cidade.toUpperCase() ? capitaliza(cidade) : cidade, uf, lat, lng, temCoord: lat != null && lng != null, fonte: String(o.fonte || '') };
  }
  const mesmoLugar = (a, b) => !!(a && b && a.cidade && b.cidade && semAcento(a.cidade) === semAcento(b.cidade) && a.uf === b.uf);
  const nomeLugar = (l) => (l ? [l.cidade, l.uf].filter(Boolean).join(', ') : '');
  const TRANSP = { correios: 'Correios', jadlog: 'Jadlog', loggi: 'Loggi', jtexpress: 'J&T Express', jt: 'J&T Express', 'j&t': 'J&T Express', totalexpress: 'Total Express', buslog: 'Buslog', shippify: 'Shippify', dhl: 'DHL', fedex: 'FedEx', ups: 'UPS', azul: 'Azul Cargo', azulcargo: 'Azul Cargo' };
  function nomeTransp(v) {
    const t = String(v || '').trim();
    if (!t) return '';
    const k = semAcento(t).replace(/[^a-z&]/g, '');
    return TRANSP[k] || (t === t.toLowerCase() ? t.charAt(0).toUpperCase() + t.slice(1) : t);
  }
  // "Correios Sedex" vira "SEDEX": o nome da transportadora ja aparece do lado
  function nomeServico(v, transp) {
    let t = String(v || '').trim().replace(/_/g, ' ');
    if (transp && semAcento(t).startsWith(semAcento(transp) + ' ')) t = t.slice(transp.length + 1).trim();
    return /^(sedex|pac|mini)$/i.test(t) ? t.toUpperCase() : t;
  }
  function km(a, b) {
    const r = Math.PI / 180;
    const x = Math.sin(((b.lat - a.lat) * r) / 2) ** 2 + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(((b.lng - a.lng) * r) / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }
  const milhar = (n) => Math.round(n).toLocaleString('pt-BR');
  // codigo de qualquer transportadora: sem espacos, pontos e tracos (o e-mail pode colar um traco diferente do
  // hifen), em maiusculas, de 6 a 40 letras e numeros, com pelo menos um numero (a mesma regra do servico de rastreio)
  const limpaCodigo = (v) => String(v || '').trim().replace(/[\s.\p{Pd}]+/gu, '').toUpperCase();
  const codigoOk = (c) => /^[A-Z0-9]{6,40}$/.test(c) && /\d/.test(c);
  // cpf com pontos e traco nao e codigo de rastreio: e barrado antes da limpeza, que o deixaria com 11 numeros
  const pareceCpf = (v) => /^\s*\d{3}\.\d{3}\.\d{3}\p{Pd}\d{2}\s*$/u.test(String(v || ''));

  /* ---------- resposta do servico > formato interno ----------
     aceita o formato curto combinado com o tema ({status, transportadora, codigo, previsao:{de,ate}, origem, destino,
     atual, eventos}) e o do servico de rastreio ({ok, pedido, envios:[{codigo, transportadora:{nome,servico},
     status:{id,etapa,rotulo}, previsaoEntrega, datas, origem, destino, posicaoEstimada, eventos, linkTransportadora,
     atualizadoEm}]}). erros: {ok:false, erro}. */
  function erro(cod, mensagem) {
    const e = new Error(cod || 'indisponivel');
    e.cod = cod || 'indisponivel';
    e.mensagem = mensagem || '';
    return e;
  }
  function normalizaEnvio(e, base) {
    if (!e || typeof e !== 'object') return null;
    const tr = e.transportadora || e.carrier || '';
    const nome = nomeTransp(typeof tr === 'object' ? tr.nome || tr.name || tr.id : tr);
    const transportadora = { nome, servico: nomeServico((typeof tr === 'object' && (tr.servico || tr.service)) || e.servico || e.service, nome) };
    const brutos = e.eventos || e.events || e.eventHistory || [];
    const eventos = (Array.isArray(brutos) ? brutos : []).map((ev) => {
      const descricao = String(ev.descricao || ev.description || ev.status_description || '').trim();
      const dele = etapaDe(ev.status) || etapaDe(ev.etapa);
      return {
        data: data(ev.data || ev.timestamp || ev.date || ev.created_at),
        local: limpaLocal(ev.local || ev.location || ''),
        descricao,
        etapa: dele && dele !== 'sem_info' ? dele : etapaDe(descricao),
        lat: num(ev.lat),
        lng: num(ev.lng),
      };
    }).filter((ev) => ev.descricao || ev.local);
    eventos.sort((a, b) => (b.data ? b.data.getTime() : -Infinity) - (a.data ? a.data.getTime() : -Infinity));

    const st = e.status;
    let etapa = null;
    if (st && typeof st === 'object') etapa = etapaDe(st.etapa) || POR_ID[num(st.id)] || etapaDe(st.rotulo) || etapaDe(st.nome);
    else etapa = etapaDe(st);
    if (!etapa) etapa = (eventos[0] && eventos[0].etapa) || 'sem_info';

    const p = e.previsao;
    let de = null;
    let ate = null;
    if (p && typeof p === 'object') { de = data(p.de || p.inicio || p.min); ate = data(p.ate || p.fim || p.max); }
    if (!de && !ate) de = ate = data(typeof p === 'string' ? p : e.previsaoEntrega || e.estimatedDelivery);
    if (de && !ate) ate = de;
    if (ate && !de) de = ate;
    if (de && ate && de > ate) [de, ate] = [ate, de];

    const origem = lugar(e.origem) || base.origem;
    if (origem && !origem.temCoord && base.origem && semAcento(origem.cidade) === semAcento(base.origem.cidade)) Object.assign(origem, { lat: base.origem.lat, lng: base.origem.lng, temCoord: base.origem.temCoord });
    const destino = lugar(e.destino || e.destination);
    const atual = lugar(e.atual || e.posicaoEstimada || e.posicao);
    // o servico avisa quando sai e chega na mesma cidade, e o aviso dele vale; sem o aviso, compara cidade e uf ou
    // centros a menos de 2 km
    const perto = !!(origem && destino && origem.temCoord && destino.temCoord && km(origem, destino) < 2);
    const mesma = typeof e.mesmaCidade === 'boolean' ? e.mesmaCidade : mesmoLugar(origem, destino) || perto;

    // etapa mais longe que os eventos ja mostraram (para pintar a trilha quando o status atual e um problema)
    let passo = PASSO[etapa];
    if (passo == null) passo = eventos.reduce((m, ev) => Math.max(m, PASSO[ev.etapa] || 0), 0);
    const ds = e.datas || {};
    const link = String(e.linkTransportadora || e.link || e.trackUrlSite || e.trackUrl || '');

    // rotulo especifico do servico (ex.: "Extraviado", "Aguardando retirada"), quando vier
    const rotulo = String((st && typeof st === 'object' ? st.rotulo : e.rotulo) || '').trim();
    return {
      codigo: String(e.codigo || e.trackingNumber || e.tracking_number || base.codigo || '').trim(),
      transportadora,
      etapa,
      rotulo: rotulo.length <= 34 ? rotulo : '',
      passo,
      alerta: etapa === 'problema' || etapa === 'cancelado',
      progresso: num(e.progresso),
      previsao: { de, ate },
      entregueEm: data(ds.entregue || e.entregueEm || e.deliveredAt) || (etapa === 'entregue' ? (eventos.find((ev) => ev.etapa === 'entregue') || eventos[0] || {}).data || null : null),
      origem,
      destino,
      mesma,
      atual: atual && atual.temCoord ? atual : null,
      eventos,
      link: /^https:\/\//i.test(link) ? link : '',
      atualizado: data(e.atualizadoEm || e.atualizado || e.updatedAt) || (eventos[0] && eventos[0].data) || null,
    };
  }
  function normaliza(json, base) {
    if (!json || typeof json !== 'object') throw erro('indisponivel');
    if (json.ok === false || (json.erro && !json.envios)) throw erro(json.erro || 'indisponivel');
    const lista = Array.isArray(json.envios) ? json.envios : Array.isArray(json.data) ? json.data : [json];
    const envios = lista.map((e) => normalizaEnvio(e, base)).filter(Boolean);
    if (!envios.length) throw erro('nao_encontrado');
    return { pedido: json.pedido || '', envios };
  }

  async function consulta(endpoint, corpo) {
    const ctl = new AbortController();
    // o servico pode levar uns 25s na primeira consulta (transportadora e localizacao das cidades)
    const t = setTimeout(() => ctl.abort(), 30000);
    let r;
    try {
      r = await fetch(endpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(corpo), signal: ctl.signal, credentials: 'omit', cache: 'no-store' });
    } catch (e) {
      throw erro('indisponivel');
    } finally {
      clearTimeout(t);
    }
    let json = null;
    try { json = await r.json(); } catch (e) { /* resposta sem json */ }
    if (json && json.ok === false) throw erro(json.erro, json.mensagem);
    if (r.status === 404) throw erro('nao_encontrado');
    if (r.status === 429) throw erro('limite');
    if (r.status === 400) throw erro('dados_invalidos');
    if (!r.ok || !json) throw erro('indisponivel');
    return json;
  }

  /* ---------- pedido de exemplo (datas relativas a agora, para o exemplo nunca envelhecer) ---------- */
  // codigo do exemplo sem o formato de nenhuma transportadora (a loja envia por mais de uma)
  const DEMO_COD = 'DEMO482915736';
  const RECIFE = { cidade: 'Recife', uf: 'PE', lat: -8.0476, lng: -34.877 };
  function amostra(etapa, origem, codigo) {
    const agora = Date.now();
    const iso = (min) => new Date(agora + min * 60000).toISOString();
    const diaIso = (n) => {
      const sp = new Date(agora - 3 * HORA + n * DIA);
      return sp.toISOString().slice(0, 10);
    };
    const sbo = nomeLugar(origem) || "Santa Bárbara d'Oeste, SP";
    const ev = [
      [-4380, 'Etiqueta criada e pedido embalado', sbo],
      [-4170, 'Objeto postado', sbo],
      [-3930, `Objeto em transferência: de agência em ${sbo} para unidade de tratamento em Campinas, SP`, sbo],
      [-3310, 'Objeto recebido na unidade de tratamento', 'Campinas, SP', -22.9056, -47.0608],
      [-2900, 'Objeto em transferência: de Campinas, SP para Belo Horizonte, MG', 'Campinas, SP', -22.9056, -47.0608],
      [-1590, 'Objeto recebido na unidade de tratamento', 'Belo Horizonte, MG', -19.9167, -43.9345],
      [-1300, 'Objeto em transferência: de Belo Horizonte, MG para Recife, PE', 'Belo Horizonte, MG', -19.9167, -43.9345],
      [-140, 'Objeto em trânsito: passou pela unidade de Feira de Santana, BA', 'Feira de Santana, BA', -12.2664, -38.9663],
    ];
    const res = {
      codigo: codigo || DEMO_COD,
      transportadora: { nome: 'Correios', servico: 'SEDEX' },
      status: etapa,
      origem,
      destino: RECIFE,
      previsao: { de: diaIso(1), ate: diaIso(2) },
      atual: { cidade: 'Feira de Santana', uf: 'BA', lat: -12.2664, lng: -38.9663 },
      eventos: ev,
      atualizadoEm: iso(-12),
    };
    if (etapa === 'criado') {
      res.eventos = ev.slice(0, 1).map((e) => [e[0] + 4300, e[1], e[2]]);
      res.atual = origem;
      res.previsao = { de: diaIso(4), ate: diaIso(6) };
    } else if (etapa === 'postado') {
      res.eventos = ev.slice(0, 2).map((e) => [e[0] + 4100, e[1], e[2]]);
      res.atual = origem;
      res.previsao = { de: diaIso(3), ate: diaIso(5) };
    } else if (etapa === 'saiu' || etapa === 'entregue') {
      res.eventos = ev.map((e) => [e[0] - 900, e[1], e[2], e[3], e[4]]).concat([
        [-610, 'Objeto recebido na unidade de distribuição', 'Recife, PE', -8.0476, -34.877],
        [-95, 'Objeto saiu para entrega ao destinatário', 'Recife, PE', -8.0476, -34.877],
      ]);
      res.atual = { cidade: 'Recife', uf: 'PE', lat: -8.112, lng: -34.94 };
      res.previsao = { de: diaIso(0), ate: diaIso(0) };
      if (etapa === 'entregue') {
        res.eventos.push([-24, 'Objeto entregue ao destinatário', 'Recife, PE', -8.0476, -34.877]);
        res.atual = RECIFE;
      }
    } else if (etapa === 'problema') {
      res.eventos = ev.concat([[-30, 'Objeto não entregue: endereço insuficiente. Ele volta para a unidade de distribuição.', 'Recife, PE', -8.0476, -34.877]]);
      res.atual = { cidade: 'Recife', uf: 'PE', lat: -8.112, lng: -34.94 };
    } else if (etapa === 'cancelado') {
      res.eventos = ev.slice(0, 2).map((e) => [e[0] + 4100, e[1], e[2]]).concat([[-40, 'Envio cancelado pelo remetente', sbo]]);
      res.atual = origem;
      res.previsao = null;
    }
    res.eventos = res.eventos.map(([min, descricao, local, lat, lng]) => ({ data: iso(min), descricao, local, lat, lng }));
    return { pedido: '', envios: [res] };
  }

  /* ---------- geometria da rota (no plano de mercator, como o mapa desenha) ---------- */
  const merc = (p) => ({ x: (p.lng + 180) / 360, y: (1 - Math.log(Math.tan(Math.PI / 4 + (p.lat * Math.PI) / 360)) / Math.PI) / 2 });
  const desmerc = (q) => ({ lng: q.x * 360 - 180, lat: (360 / Math.PI) * Math.atan(Math.exp(Math.PI * (1 - 2 * q.y))) - 90 });
  // arco suave de a para b, curvado para a esquerda de quem vai (no brasil, puxa para o interior)
  function arco(a, b, curva, n) {
    const A = merc(a);
    const B = merc(b);
    const dx = B.x - A.x;
    const dy = B.y - A.y;
    const C = { x: (A.x + B.x) / 2 + dy * curva, y: (A.y + B.y) / 2 - dx * curva };
    const pts = [];
    for (let i = 0; i <= n; i++) {
      const t = i / n;
      const u = 1 - t;
      pts.push({ x: u * u * A.x + 2 * u * t * C.x + t * t * B.x, y: u * u * A.y + 2 * u * t * C.y + t * t * B.y });
    }
    return pts;
  }
  function comprimento(pts) {
    const ac = [0];
    for (let i = 1; i < pts.length; i++) ac.push(ac[i - 1] + Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y));
    return ac;
  }
  // ponto e rumo a uma fracao do caminho
  function aoLongo(linha, f) {
    const { pts, ac } = linha;
    const total = ac[ac.length - 1] || 1;
    const alvo = Math.max(0, Math.min(1, f)) * total;
    let i = 1;
    while (i < pts.length - 1 && ac[i] < alvo) i++;
    const a = pts[i - 1];
    const b = pts[i] || a;
    const seg = ac[i] - ac[i - 1] || 1;
    const t = Math.max(0, Math.min(1, (alvo - ac[i - 1]) / seg));
    return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t, dx: b.x - a.x, dy: b.y - a.y, i };
  }
  function corta(linha, f) {
    const p = aoLongo(linha, f);
    return linha.pts.slice(0, p.i).concat([{ x: p.x, y: p.y }]);
  }
  // rota inteira: origem > cidades por onde o pacote passou (eventos com coordenada) > destino.
  // sem cidades, origem > posicao atual > destino; sem posicao, o caminhao fica na fracao da etapa.
  // saiu para entrega e entregue: o caminhao estaciona um pouco antes da casa, para nao cobrir o pino
  const PARADA = { saiu: 0.86, retirada: 0.88, entregue: 0.9 };
  function caminho(pontos, curva) {
    const pts = [];
    for (let i = 1; i < pontos.length; i++) {
      const n = Math.max(8, Math.min(64, Math.round(km(pontos[i - 1], pontos[i]) / 25)));
      const seg = arco(pontos[i - 1], pontos[i], curva, n);
      for (let k = i > 1 ? 1 : 0; k < seg.length; k++) pts.push(seg[k]);
    }
    return pts;
  }
  function montaRota(envio) {
    const o = envio.origem;
    const d = envio.destino;
    if (!o || !o.temCoord || !d || !d.temCoord) return null;
    // mesma cidade: loja e casa caem no mesmo centro de cidade. sem tracado; o mapa fecha na cidade e o caminhao
    // entra pela esquerda e para antes da casa (mais longe dela enquanto nao saiu para entrega)
    if (envio.mesma) {
      const D = merc(d);
      const longe = envio.etapa === 'entregue' ? 1.45 : envio.etapa === 'saiu' || envio.etapa === 'retirada' ? 1.8 : 3;
      const rota = { total: 0, resto: 0, paradas: [], rumo: 90, mesma: true, falta: [] };
      rota.estaciona = (escala, tam) => {
        const u = tam / escala;
        const fim = { x: D.x - u * longe, y: D.y + u * 0.2 };
        const pts = [{ x: fim.x - u * 4, y: fim.y }, fim];
        rota.feito = { pts, ac: comprimento(pts) };
        rota.paraEm = 1;
        rota.pos = { x: fim.x, y: fim.y, dx: 1, dy: 0, i: 1 };
      };
      rota.estaciona(512 * Math.pow(2, 12), 90);
      return rota;
    }
    const total = km(o, d);
    const a = envio.atual;
    const paradas = [];
    envio.eventos.slice().reverse().forEach((ev) => {
      if (ev.lat == null || ev.lng == null) return;
      const p = { lat: ev.lat, lng: ev.lng };
      if (km(paradas[paradas.length - 1] || o, p) > 25) paradas.push(p);
    });
    if (!paradas.length && a && km(o, a) > 25 && km(a, d) > 25 && envio.etapa !== 'entregue') paradas.push(a);
    const ultima = paradas[paradas.length - 1];
    const perto = (ultima && km(ultima, d) <= 25) || (a && km(a, d) <= 25);
    while (paradas.length && km(paradas[paradas.length - 1], d) <= 25) paradas.pop();
    const parada = PARADA[envio.etapa] || (perto ? PARADA.saiu : null);
    const curva = paradas.length > 1 ? 0.1 : paradas.length ? 0.14 : 0.2;
    const rota = { total, paradas };
    const fixaPos = () => {
      let pos = aoLongo(rota.feito, rota.paraEm);
      if (Math.hypot(pos.dx, pos.dy) < 1e-12 && rota.falta.length > 1) pos = { x: pos.x, y: pos.y, dx: rota.falta[1].x - rota.falta[0].x, dy: rota.falta[1].y - rota.falta[0].y };
      rota.pos = pos;
    };
    let resto;
    if (parada || envio.etapa === 'entregue' || !paradas.length) {
      const cheio = caminho([o].concat(paradas, [d]), curva);
      const linha = { pts: cheio, ac: comprimento(cheio) };
      const L = linha.ac[linha.ac.length - 1];
      // recorta a rota com o caminhao na fracao f do caminho cheio
      const recorta = (f) => {
        rota.solto = null;
        rota.paraEm = 1;
        if (envio.etapa === 'entregue') {
          rota.feito = linha;
          rota.falta = [];
          rota.paraEm = f;
        } else {
          const q = aoLongo(linha, f);
          const feito = corta(linha, f);
          rota.feito = { pts: feito, ac: comprimento(feito) };
          rota.falta = [{ x: q.x, y: q.y }].concat(cheio.slice(q.i));
        }
        fixaPos();
      };
      const f0 = parada || (envio.progresso != null ? envio.progresso : POSICAO[envio.etapa] != null ? POSICAO[envio.etapa] : 0.02);
      recorta(f0);
      // perto da casa (ou saindo da loja) a distancia certa depende do zoom: quem desenha chama estaciona(px por unidade)
      if (parada) rota.estaciona = (escala, tam) => recorta(Math.max(0.55, Math.min(0.97, 1 - (tam * 1.5) / (L * escala))));
      else if (!paradas.length && ['criado', 'postado', 'cancelado'].includes(envio.etapa)) rota.estaciona = (escala, tam) => recorta(Math.max(0.02, Math.min(0.45, (tam * 1.2) / (L * escala))));
      resto = parada ? 0 : total * (1 - f0);
    } else {
      // em transito com cidades: o caminho feito passa por elas e o que falta sai da ultima
      const feito = caminho([o].concat(paradas), curva);
      rota.feito = { pts: feito, ac: comprimento(feito) };
      rota.falta = arco(paradas[paradas.length - 1], d, 0.14, 48);
      rota.paraEm = 1;
      fixaPos();
      resto = km(paradas[paradas.length - 1], d);
    }
    // rumo da rota (graus a partir do norte), para girar o mapa a favor dela
    const A = merc(o);
    const B = merc(d);
    const rumo = (Math.atan2(B.x - A.x, -(B.y - A.y)) * 180) / Math.PI;
    // cancelado: o pacote nao segue viagem, entao o tracejado do que falta nao aparece
    return Object.assign(rota, { resto, rumo, semFalta: envio.etapa === 'cancelado' });
  }

  // caixa (na tela) da cabeca do pino ancorado pela ponta em p: gota de lado s, com a ponta para baixo e a sombra
  // para a direita
  const cabecaPino = (p, s, mb) => {
    const cy = p.y - mb - s / 2;
    return { l: p.x - s / 2 - 4, r: p.x + s / 2 + 8, t: cy - s / 2 - 4, b: cy + s * 0.71 + 4 };
  };
  // o caminhao nunca para embaixo (ou em cima) do pino da loja: no quadro em que ele vai ser visto, anda pela rota
  // ate sair da cabeca do pino, no maximo ate a metade do que falta. tela(q) leva um ponto da rota para a tela e
  // carro(p) e a caixa do caminhao parado no ponto p da tela
  function afastaDaLoja(rota, tela, pino, carro) {
    if (!rota || rota.mesma) return;
    // parte sempre de onde a rota pos o caminhao: o desenho chama de novo a cada largura
    const nat = rota.solto || (rota.solto = { feito: rota.feito, falta: rota.falta, paraEm: rota.paraEm, pos: rota.pos });
    Object.assign(rota, { feito: nat.feito, falta: nat.falta, paraEm: nat.paraEm, pos: nat.pos });
    if (nat.falta.length < 2 || nat.paraEm < 1) return;
    const cheia = nat.feito.pts.concat(nat.falta.slice(1));
    const linha = { pts: cheia, ac: comprimento(cheia) };
    const L = linha.ac[linha.ac.length - 1];
    if (!L) return;
    const f0 = nat.feito.ac[nat.feito.ac.length - 1] / L;
    // uns px de folga em volta do pino: o caminhao nao encosta na cabeca dele
    const M = 6;
    const cobre = (f) => {
      const c = carro(tela(aoLongo(linha, f)));
      return c.r > pino.l - M && c.l < pino.r + M && c.b > pino.t - M && c.t < pino.b + M;
    };
    if (!cobre(f0)) return;
    const ate = f0 + (1 - f0) / 2;
    let f = ate;
    for (let i = 1; i <= 240; i++) {
      const g = f0 + ((ate - f0) * i) / 240;
      if (!cobre(g)) { f = g; break; }
    }
    const p = aoLongo(linha, f);
    const feito = corta(linha, f);
    rota.feito = { pts: feito, ac: comprimento(feito) };
    rota.falta = [{ x: p.x, y: p.y }].concat(cheia.slice(p.i));
    rota.paraEm = 1;
    rota.pos = p;
  }

  const geo = (pts) => ({ type: 'Feature', properties: {}, geometry: { type: 'LineString', coordinates: pts.map((q) => { const p = desmerc(q); return [p.lng, p.lat]; }) } });

  /* ---------- marcadores (os mesmos no desenho e no mapa 3d) ---------- */
  // a origem e a loja; quando a transportadora informa que o pacote saiu de outra cidade, o pino (e o icone da
  // legenda) vira um pacote com o nome dessa cidade (o n da marca ficaria num lugar onde a loja nao esta)
  const origemOutra = (textos, envio) => {
    const o = envio && envio.origem;
    return !!(o && o.fonte === 'envia' && o.cidade && !mesmoLugar(o, textos.origem));
  };
  const icoOrigem = (outra) => (outra ? svgUso('rast-i-caixa', 'stroke="currentColor" stroke-width="2.2"') : svgUso('fx-n', 'viewBox="0 0 252 403" fill="currentColor"'));
  function marcaLoja(textos, envio) {
    const o = envio && envio.origem;
    const outra = origemOutra(textos, envio);
    const m = el('div', 's-rast__pin s-rast__pin--loja' + (outra ? ' is-outra' : ''));
    const ico = icoOrigem(outra);
    m.innerHTML = `<span class="s-rast__pin-cabeca">${ico}</span>`;
    m.appendChild(el('span', 's-rast__pin-rot', outra ? nomeLugar(o) : textos.origem.nome || 'Loja'));
    return m;
  }
  function marcaCasa(envio) {
    const m = el('div', 's-rast__pin s-rast__pin--casa' + (envio && envio.etapa === 'entregue' ? ' is-entregue' : ''));
    m.innerHTML = `<span class="s-rast__pin-onda"></span><span class="s-rast__pin-cabeca">${svgUso('rast-i-casa', 'stroke="currentColor" stroke-width="2.4"')}</span>`;
    m.appendChild(el('span', 's-rast__pin-rot', envio ? nomeLugar(envio.destino) : ''));
    if (envio && envio.etapa === 'entregue') {
      const confete = el('span', 's-rast__confete');
      for (let i = 0; i < 10; i++) confete.appendChild(el('i'));
      m.appendChild(confete);
    }
    return m;
  }
  // o mapa move o marcador por transform: o balao (que tem transform proprio) vai dentro de uma ancora
  function bolha(rosto, frase) {
    const ancora = el('div', 's-rast__bolha-ancora');
    const b = el('div', 's-rast__bolha');
    ancora.appendChild(b);
    const rostoEl = el('span', 's-rast__bolha-rosto');
    const img = el('img');
    img.src = rosto;
    img.alt = '';
    img.width = 176;
    img.height = 176;
    img.decoding = 'async';
    rostoEl.appendChild(img);
    b.appendChild(rostoEl);
    b.appendChild(el('span', 's-rast__bolha-fala', frase));
    return ancora;
  }
  const CAMINHAO_SVG = '<svg viewBox="0 0 76 46" aria-hidden="true" focusable="false"><g stroke="#05070a" stroke-width="3" stroke-linejoin="round"><rect x="2.5" y="4.5" width="44" height="29" rx="4" fill="#fff"/><path d="M46.5 13.5h15l11 11v9h-26z" fill="url(#fx-grad)"/><path d="M52 16.5h8l7 7.5H52z" fill="#11161d" stroke-width="2.4"/><rect x="2.5" y="31.5" width="70" height="5" rx="2" fill="#05070a"/><circle cx="16" cy="37.5" r="6.2" fill="#1a2028"/><circle cx="59" cy="37.5" r="6.2" fill="#1a2028"/></g><circle cx="16" cy="37.5" r="2" fill="#b4bec9"/><circle cx="59" cy="37.5" r="2" fill="#b4bec9"/><rect x="5.5" y="24" width="38" height="5" fill="url(#fx-grad)"/><use href="#fx-n" x="18" y="8" width="10" height="15" fill="#05070a"/></svg>';
  function caminhao2d(direita) {
    const c = el('div', 's-rast__cam2d' + (direita ? '' : ' is-volta'));
    c.innerHTML = `<span class="s-rast__cam2d-corpo">${CAMINHAO_SVG}</span><span class="s-rast__cam2d-sombra"></span>`;
    return c;
  }

  // arruma o balao e os nomes dos pinos: o balao escolhe o lado (--desvio e quanto ele anda para a esquerda; o
  // rabicho fica no caminhao) e cada nome vai para cima, baixo, direita ou esquerda do seu pino (em cima e embaixo,
  // centrado ou alinhado a uma ponta), o que cobrir menos o caminhao, os pinos, a legenda e os creditos do mapa
  // (em cima e centrado e o normal). tudo medido na tela, dentro da caixa.
  // com podeVirar falso os nomes ficam onde estao (enquanto o caminhao anda, para nao piscar)
  const LADO_ROT = [null, 'is-baixo', 'is-direita', 'is-esquerda', 'is-cima-ini', 'is-cima-fim', 'is-baixo-ini', 'is-baixo-fim'];
  const LADO_CUSTO = [0, 250, 320, 320, 150, 150, 300, 300];
  function arruma(o) {
    const { ancora, x, y, caixa } = o;
    const b = ancora.firstChild;
    const largura = caixa.clientWidth;
    if (!b || !largura) return;
    const w = b.offsetWidth || 220;
    const h = b.offsetHeight || 64;
    const r = parseFloat(getComputedStyle(b).getPropertyValue('--r')) || 66;
    const base = caixa.getBoundingClientRect();
    const rel = (q) => ({ l: q.left - base.left, t: q.top - base.top, r: q.right - base.left, b: q.bottom - base.top });
    const folga = (a, m) => ({ l: a.l - m, t: a.t - m, r: a.r + m, b: a.b + m });
    const cruza = (a, c) => Math.max(0, Math.min(a.r, c.r) - Math.max(a.l, c.l)) * Math.max(0, Math.min(a.b, c.b) - Math.max(a.t, c.t));
    const fixos = [];
    (caixa.closest('[data-rast-mapa]') || caixa).querySelectorAll('.s-rast__legenda, .maplibregl-ctrl-attrib').forEach((e) => {
      const q = e.getBoundingClientRect();
      if (q.width) fixos.push(folga(rel(q), 6));
    });
    const pinos = o.pinos.filter((p) => p && p.isConnected).map((p) => {
      const caixaP = rel(p.getBoundingClientRect());
      const cab = folga(rel(p.querySelector('.s-rast__pin-cabeca').getBoundingClientRect()), 4);
      const rot = p.querySelector('.s-rast__pin-rot');
      const q = rot && rot.getBoundingClientRect();
      if (!q || !q.width) return { p, cab, rots: null };
      const cx = (caixaP.l + caixaP.r) / 2;
      const lw = q.width;
      const lh = q.height;
      const rots = [
        { l: cx - lw / 2, r: cx + lw / 2, t: caixaP.t - 6 - lh, b: caixaP.t - 6 },
        { l: cx - lw / 2, r: cx + lw / 2, t: caixaP.b + 14, b: caixaP.b + 14 + lh },
        { l: caixaP.r + 10, r: caixaP.r + 10 + lw, t: caixaP.t + 13, b: caixaP.t + 13 + lh },
        { l: caixaP.l - 10 - lw, r: caixaP.l - 10, t: caixaP.t + 13, b: caixaP.t + 13 + lh },
        { l: caixaP.l - 4, r: caixaP.l - 4 + lw, t: caixaP.t - 6 - lh, b: caixaP.t - 6 },
        { l: caixaP.r + 4 - lw, r: caixaP.r + 4, t: caixaP.t - 6 - lh, b: caixaP.t - 6 },
        { l: caixaP.l - 4, r: caixaP.l - 4 + lw, t: caixaP.b + 14, b: caixaP.b + 14 + lh },
        { l: caixaP.r + 4 - lw, r: caixaP.r + 4, t: caixaP.b + 14, b: caixaP.b + 14 + lh },
      ].map((a) => folga(a, 5));
      return { p, cab, rots, atual: Math.max(0, LADO_ROT.findIndex((c) => c && p.classList.contains(c))) };
    });
    let combos = [[]];
    pinos.forEach((pi) => {
      const opcoes = !pi.rots ? [null] : o.podeVirar ? LADO_ROT.map((c, k) => k) : [pi.atual];
      combos = combos.flatMap((c) => opcoes.map((v) => c.concat([v])));
    });
    const centro = x + r * 0.21;
    let melhor = { custo: Infinity, lado: 0, cfg: [] };
    combos.forEach((cfg) => {
      const nomes = pinos.map((pi, i) => (cfg[i] == null ? null : pi.rots[cfg[i]]));
      let fixo = 0;
      nomes.forEach((n, i) => {
        if (!n) return;
        if (o.carro) fixo += cruza(n, o.carro) * 2;
        fixos.forEach((f) => { fixo += cruza(n, f) * 2; });
        pinos.forEach((pj, j) => { if (j !== i) fixo += cruza(n, pj.cab) * 2 + (j > i && nomes[j] ? cruza(n, nomes[j]) * 2 : 0); });
        if (n.t < 0 || n.b > caixa.clientHeight || n.l < 0 || n.r > largura) fixo += 6000;
        fixo += LADO_CUSTO[cfg[i]];
      });
      [0.38, 0.26, 0.13, 0, -0.12, -0.24].forEach((lado) => {
        const bo = { l: centro - w / 2 - lado * w - r * 0.42, r: centro + w / 2 - lado * w, t: y - h - 8, b: y + 4 };
        let c = fixo + Math.abs(lado) * 400;
        // nome escondido atras do balao pesa mais: some o texto
        pinos.forEach((pi, i) => { c += cruza(bo, pi.cab) + (nomes[i] ? cruza(bo, nomes[i]) * 3 : 0); });
        fixos.forEach((f) => { c += cruza(bo, f); });
        if (bo.l < 10) c += (10 - bo.l) * h * 3;
        if (bo.r > largura - 66) c += (bo.r - (largura - 66)) * h * 3;
        if (c < melhor.custo) melhor = { custo: c, lado, cfg };
      });
    });
    ancora.style.setProperty('--desvio', `${Math.round(melhor.lado * w)}px`);
    pinos.forEach((pi, i) => {
      if (melhor.cfg[i] == null) return;
      LADO_ROT.forEach((c, k) => { if (c) pi.p.classList.toggle(c, k === melhor.cfg[i]); });
    });
  }

  /* ---------- desenho da rota em svg (sem 3d, e enquanto o mapa carrega) ---------- */
  const PTS_BR = BRASIL.split(' ').map((s) => { const [lng, lat] = s.split(',').map(Number); return merc({ lng, lat }); });
  const DESTINOS_VAZIO = [
    { lat: -8.0476, lng: -34.877 }, { lat: -3.119, lng: -60.0217 }, { lat: -30.0346, lng: -51.2177 }, { lat: -15.7939, lng: -47.8828 },
    { lat: -3.7319, lng: -38.5267 }, { lat: -1.4558, lng: -48.4902 }, { lat: -27.5954, lng: -48.548 }, { lat: -20.4697, lng: -54.6201 },
  ];
  let uid = 0;
  function desenhaSvg(caixa, envio, rota, textos, extras) {
    const W = Math.max(280, caixa.clientWidth || 600);
    const H = Math.max(240, caixa.clientHeight || 420);
    const vazio = !envio;
    // sem rota, o brasil inteiro; com rota, o quadro fecha nela (com folga) e o contorno do pais passa da borda.
    // mesma cidade: um quadro de uns 3 graus em volta da cidade
    let pontos = rota ? rota.feito.pts.concat(rota.falta) : PTS_BR.slice();
    if (rota && rota.mesma) {
      const D = merc(envio.destino);
      pontos = [{ x: D.x - 0.0035, y: D.y - 0.0028 }, { x: D.x + 0.0035, y: D.y + 0.0028 }];
    }
    let x0 = Infinity;
    let x1 = -Infinity;
    let y0 = Infinity;
    let y1 = -Infinity;
    pontos.forEach((q) => { x0 = Math.min(x0, q.x); x1 = Math.max(x1, q.x); y0 = Math.min(y0, q.y); y1 = Math.max(y1, q.y); });
    if (rota) {
      const m = Math.max(x1 - x0, y1 - y0, 0.004) * 0.22;
      x0 -= m; x1 += m; y0 -= m; y1 += m;
    }
    const folga = extras.folga || { t: 0.16, r: 0.06, b: 0.2, l: 0.06 };
    const w = x1 - x0;
    const h = y1 - y0;
    let k = Math.min((W * (1 - folga.l - folga.r)) / w, (H * (1 - folga.t - folga.b)) / h);
    let ox = W * folga.l + (W * (1 - folga.l - folga.r) - w * k) / 2 - x0 * k;
    const oy = H * folga.t + (H * (1 - folga.t - folga.b) - h * k) / 2 - y0 * k;
    const px = (q) => ({ x: q.x * k + ox, y: q.y * k + oy });
    if (rota && rota.estaciona) rota.estaciona(k, 80);
    // mesma cidade: o balao fica a esquerda do caminhao; no quadro estreito o caminhao vai mais para o meio
    if (rota && rota.mesma) {
      const D = merc(envio.destino);
      ox = W / 2 - (rota.pos.x + (D.x - rota.pos.x) * (W < 640 ? 0.15 : 0.5)) * k;
    }
    const caminho = (pts) => pts.map((q, i) => { const p = px(q); return `${i ? 'L' : 'M'}${p.x.toFixed(1)} ${p.y.toFixed(1)}`; }).join('');
    const n = ++uid;
    const br = caminho(PTS_BR) + 'Z';
    let rotas = '';
    let origemPx = null;
    let destinoPx = null;
    let posPx = null;
    const o = envio ? envio.origem : textos.origem;
    if (o && o.temCoord && !(rota && rota.mesma)) origemPx = px(merc(o));
    // o caminhao do desenho (78 x 47 px, 78% acima do ponto) nao para em cima do pino da loja
    if (rota && origemPx) afastaDaLoja(rota, px, cabecaPino(origemPx, 50, 9), (p) => ({ l: p.x - 39, r: p.x + 39, t: p.y - 37, b: p.y + 16 }));
    if (rota && rota.mesma) {
      destinoPx = px(merc(envio.destino));
      posPx = px(rota.pos);
    } else if (rota) {
      destinoPx = px(merc(envio.destino));
      posPx = px(rota.pos);
      const a = origemPx;
      const b = posPx;
      if (rota.falta.length > 1 && !rota.semFalta) rotas += `<path d="${caminho(rota.falta)}" fill="none" stroke="#eaf7f4" stroke-opacity=".55" stroke-width="2.6" stroke-linecap="round" stroke-dasharray="1 7"/>`;
      if (rota.feito.pts.length > 1) {
        rotas += `<linearGradient id="rast-gr${n}" gradientUnits="userSpaceOnUse" x1="${a.x}" y1="${a.y}" x2="${b.x}" y2="${b.y}"><stop offset="0" stop-color="#2fe3a8"/><stop offset="1" stop-color="#1ec8e6"/></linearGradient>`;
        const d = caminho(rota.feito.pts);
        rotas += `<path d="${d}" fill="none" stroke="#1ec8e6" stroke-opacity=".28" stroke-width="16" stroke-linecap="round" filter="url(#rast-bl${n})"/>`;
        rotas += `<path d="${d}" fill="none" stroke="#05070a" stroke-width="9" stroke-linecap="round"/>`;
        rotas += `<path class="s-rast__svg-feito" d="${d}" fill="none" stroke="url(#rast-gr${n})" stroke-width="4.6" stroke-linecap="round" pathLength="1"/>`;
      }
      (rota.paradas || []).forEach((q) => {
        const c = px(merc(q));
        rotas += `<circle cx="${c.x.toFixed(1)}" cy="${c.y.toFixed(1)}" r="5" fill="#eaf7f4" stroke="#05070a" stroke-width="2.6"/>`;
      });
    } else if (vazio && origemPx) {
      DESTINOS_VAZIO.forEach((p, i) => {
        const pts = arco(o, p, 0.18, 32);
        rotas += `<path class="s-rast__svg-raio" style="--i:${i}" d="${caminho(pts)}" fill="none" stroke="url(#rast-gv${n})" stroke-width="2.4" stroke-linecap="round" stroke-dasharray="2 7"/>`;
        const fim = px(merc(p));
        rotas += `<circle cx="${fim.x.toFixed(1)}" cy="${fim.y.toFixed(1)}" r="4.5" fill="#0b0f14" stroke="#2fe3a8" stroke-width="2.2"/>`;
      });
    }
    const grade = [];
    for (let lng = -75; lng <= -30; lng += 5) { const a = px(merc({ lng, lat: 8 })); const b = px(merc({ lng, lat: -36 })); grade.push(`M${a.x.toFixed(1)} ${a.y.toFixed(1)}L${b.x.toFixed(1)} ${b.y.toFixed(1)}`); }
    for (let lat = 5; lat >= -35; lat -= 5) { const a = px(merc({ lng: -78, lat })); const b = px(merc({ lng: -28, lat })); grade.push(`M${a.x.toFixed(1)} ${a.y.toFixed(1)}L${b.x.toFixed(1)} ${b.y.toFixed(1)}`); }
    const luz = destinoPx || origemPx || { x: W / 2, y: H / 2 };
    caixa.innerHTML = `<svg class="s-rast__svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <defs>
        <pattern id="rast-pt${n}" width="9" height="9" patternUnits="userSpaceOnUse"><circle cx="4.5" cy="4.5" r="1.15" fill="#2fe3a8" fill-opacity=".2"/></pattern>
        <radialGradient id="rast-lz${n}" gradientUnits="userSpaceOnUse" cx="${luz.x.toFixed(1)}" cy="${luz.y.toFixed(1)}" r="${(Math.max(W, H) * 0.55).toFixed(0)}"><stop offset="0" stop-color="#1ec8e6" stop-opacity=".22"/><stop offset="1" stop-color="#1ec8e6" stop-opacity="0"/></radialGradient>
        <linearGradient id="rast-gv${n}" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#2fe3a8"/><stop offset="1" stop-color="#1ec8e6"/></linearGradient>
        <filter id="rast-bl${n}" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="5"/></filter>
      </defs>
      <rect width="${W}" height="${H}" fill="#0b0f14"/>
      <rect width="${W}" height="${H}" fill="url(#rast-lz${n})"/>
      <path d="${grade.join('')}" stroke="#ffffff" stroke-opacity=".045" stroke-width="1" fill="none"/>
      <path d="${br}" fill="#05070a" transform="translate(6 8)"/>
      <path d="${br}" fill="#121b24"/>
      <path d="${br}" fill="url(#rast-pt${n})"/>
      <path d="${br}" fill="none" stroke="#27d6c4" stroke-opacity=".55" stroke-width="1.6" stroke-linejoin="round"/>
      ${rotas}
    </svg>`;
    return { origemPx, destinoPx, posPx, W, H };
  }

  /* ---------- mapa 3d ---------- */
  const LOCALE = {
    'AttributionControl.ToggleAttribution': 'Mostrar créditos do mapa',
    'AttributionControl.MapFeedback': 'Sugerir correção no mapa',
    'CooperativeGesturesHandler.WindowsHelpText': 'Use Ctrl + rolagem para dar zoom no mapa',
    'CooperativeGesturesHandler.MacHelpText': 'Use ⌘ + rolagem para dar zoom no mapa',
    'CooperativeGesturesHandler.MobileHelpText': 'Use dois dedos para mexer no mapa',
    'Map.Title': 'Mapa da rota',
    'Marker.Title': 'Marcador',
    'NavigationControl.ZoomIn': 'Aproximar',
    'NavigationControl.ZoomOut': 'Afastar',
    'NavigationControl.ResetBearing': 'Apontar para o norte',
  };
  let libs = null;
  function carregaCss(href) {
    return new Promise((ok) => {
      if (document.querySelector(`link[href="${href}"]`)) return ok();
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = l.onerror = () => ok();
      document.head.appendChild(l);
    });
  }
  function carregaLibs() {
    if (!libs) {
      libs = Promise.all([
        import(ML + 'maplibre-gl.mjs'),
        import(THREE_URL),
        fetch(ESTILO).then((r) => { if (!r.ok) throw erro('estilo'); return r.json(); }),
        carregaCss(ML + 'maplibre-gl.css'),
      ]);
      libs.catch(() => { libs = null; });
    }
    return libs;
  }
  function temWebgl() {
    try {
      const c = document.createElement('canvas');
      return !!(c.getContext('webgl2') || c.getContext('webgl'));
    } catch (e) {
      return false;
    }
  }

  // estilo escuro do openfreemap pintado com as cores da marca: terra grafite, agua petroleo, estradas discretas,
  // fronteiras em ciano. so ficam as camadas que leem bem do pais inteiro ate a cidade
  function recolore(st) {
    const C = { fundo: '#0b1117', terra: '#0f171f', mato: '#0d151c', agua: '#08262e', via: '#1a2631', viaForte: '#22323f', borda: '#05070a', texto: '#a9b8c6', halo: '#05070a' };
    const fica = {
      background: { 'background-color': C.fundo },
      water: { 'fill-color': C.agua, 'fill-antialias': true },
      waterway: { 'line-color': C.agua },
      landcover_ice_shelf: { 'fill-color': C.terra, 'fill-opacity': 0.6 },
      landcover_glacier: { 'fill-color': C.terra, 'fill-opacity': 0.5 },
      landuse_residential: { 'fill-color': '#132029', 'fill-opacity': 0.55 },
      landuse_park: { 'fill-color': C.mato },
      highway_motorway_subtle: { 'line-color': C.via },
      highway_major_subtle: { 'line-color': C.via },
      highway_motorway_casing: { 'line-color': C.borda },
      highway_motorway_inner: { 'line-color': C.viaForte },
      highway_major_casing: { 'line-color': C.borda },
      highway_major_inner: { 'line-color': C.via },
      highway_minor: { 'line-color': '#141e27' },
      boundary_state: { 'line-color': '#27d6c4', 'line-opacity': 0.3 },
      'boundary_country_z0-4': { 'line-color': '#27d6c4', 'line-opacity': 0.7 },
      'boundary_country_z5-': { 'line-color': '#27d6c4', 'line-opacity': 0.7 },
      place_state: null,
      place_city_large: null,
      place_city: null,
      place_town: null,
      place_country_major: null,
      place_country_minor: null,
      place_country_other: null,
    };
    st.layers = st.layers.filter((l) => Object.prototype.hasOwnProperty.call(fica, l.id)).map((l) => {
      const p = fica[l.id];
      if (p) l.paint = Object.assign({}, l.paint, p);
      if (l.type === 'symbol') {
        if (l.layout) delete l.layout['icon-image'];
        l.paint = Object.assign({}, l.paint, { 'text-color': /country/.test(l.id) ? '#6f8394' : /state/.test(l.id) ? '#4f6372' : C.texto, 'text-halo-color': C.halo, 'text-halo-width': 1.4, 'text-halo-blur': 0.5, 'icon-opacity': 0.55 });
        if (/state/.test(l.id)) l.layout = Object.assign({}, l.layout, { 'text-transform': 'uppercase', 'text-letter-spacing': 0.2 });
      }
      return l;
    });
    // neblina no fundo do mapa inclinado: o longe some no grafite e o horizonte acende em ciano
    st.sky = { 'sky-color': '#05070a', 'horizon-color': '#0f5560', 'fog-color': '#0b1117', 'fog-ground-blend': 0.55, 'horizon-fog-blend': 0.6, 'sky-horizon-blend': 0.7, 'atmosphere-blend': 0 };
    if (st.sources && st.sources.ne2_shaded) {
      st.layers.splice(1, 0, { id: 'rast-relevo', type: 'raster', source: 'ne2_shaded', maxzoom: 8, paint: { 'raster-opacity': 0.3, 'raster-saturation': -1, 'raster-contrast': 0.25, 'raster-brightness-max': 0.32, 'raster-fade-duration': 0 } });
    }
    return st;
  }

  // caminhao low poly montado na hora: cabine no degrade da marca, bau branco com o n, contorno preto de adesivo
  function montaCaminhao(THREE) {
    const degraus = new THREE.DataTexture(new Uint8Array([70, 150, 255]), 3, 1, THREE.RedFormat);
    degraus.minFilter = degraus.magFilter = THREE.NearestFilter;
    degraus.generateMipmaps = false;
    degraus.needsUpdate = true;
    const toon = (cor, extra) => new THREE.MeshToonMaterial(Object.assign({ color: cor, gradientMap: degraus }, extra || {}));
    const contorno = new THREE.MeshBasicMaterial({ color: 0x05070a, side: THREE.BackSide });
    const raiz = new THREE.Group();
    const corpo = new THREE.Group();
    raiz.add(corpo);
    const T = 0.06;
    // o contorno e uma copia por dentro do avesso, um pouco maior: a geometria vai para o centro para crescer por igual
    const comBorda = (malha, x, y, z, pai) => {
      const geo = malha.geometry;
      geo.computeBoundingBox();
      const c = new THREE.Vector3();
      const s = new THREE.Vector3();
      geo.boundingBox.getCenter(c);
      geo.boundingBox.getSize(s);
      geo.translate(-c.x, -c.y, -c.z);
      malha.position.set(x + c.x, y + c.y, z + c.z);
      (pai || corpo).add(malha);
      const b = new THREE.Mesh(geo, contorno);
      b.scale.set((s.x + 2 * T) / Math.max(s.x, 1e-3), (s.y + 2 * T) / Math.max(s.y, 1e-3), (s.z + 2 * T) / Math.max(s.z, 1e-3));
      malha.add(b);
      return malha;
    };

    // lateral do bau: papel branco, faixa no degrade e o n da marca (lido do sprite da pagina)
    const tela = document.createElement('canvas');
    tela.width = 512;
    tela.height = 300;
    const g = tela.getContext('2d');
    g.fillStyle = '#f6f8f8';
    g.fillRect(0, 0, 512, 300);
    const gr = g.createLinearGradient(0, 0, 512, 0);
    gr.addColorStop(0, '#2fe3a8');
    gr.addColorStop(1, '#1ec8e6');
    g.fillStyle = gr;
    g.fillRect(0, 222, 512, 78);
    g.fillStyle = '#05070a';
    g.fillRect(0, 214, 512, 10);
    const n = document.querySelector('#fx-n path');
    if (n && window.Path2D) {
      g.save();
      g.translate(34, 30);
      g.scale(0.42, 0.42);
      g.fill(new Path2D(n.getAttribute('d')));
      g.restore();
    }
    g.font = '600 50px GeBody, "Space Grotesk", sans-serif';
    g.textBaseline = 'middle';
    g.fillText('NOVA', 158, 82);
    g.fillText('TRACKERS', 158, 140);
    g.lineWidth = 12;
    g.strokeRect(6, 6, 500, 288);
    const textura = new THREE.CanvasTexture(tela);
    textura.colorSpace = THREE.SRGBColorSpace;
    textura.anisotropy = 4;
    const branco = toon(0xf6f8f8);
    const lateral = toon(0xffffff, { map: textura });

    const preto = toon(0x14191f);
    const chassi = new THREE.Mesh(new THREE.BoxGeometry(4.25, 0.26, 1.36), preto);
    chassi.position.set(-0.8, 0.42, 0);
    corpo.add(chassi);
    comBorda(new THREE.Mesh(new THREE.BoxGeometry(0.2, 0.3, 1.5), preto), 1.36, 0.5, 0);

    comBorda(new THREE.Mesh(new THREE.BoxGeometry(2.9, 1.78, 1.62), [toon(0xe9eef0), branco, branco, branco, lateral, lateral]), -1.5, 1.44, 0);

    // cabine: perfil com o nariz arredondado, extrudado na largura
    const perfil = new THREE.Shape();
    perfil.moveTo(0, 0);
    perfil.lineTo(1.18, 0);
    perfil.lineTo(1.26, 0.55);
    perfil.quadraticCurveTo(1.24, 1.05, 0.98, 1.3);
    perfil.lineTo(0, 1.3);
    perfil.lineTo(0, 0);
    const cabGeo = new THREE.ExtrudeGeometry(perfil, { depth: 1.46, bevelEnabled: true, bevelSize: 0.05, bevelThickness: 0.05, bevelSegments: 2, curveSegments: 8 });
    cabGeo.translate(0, 0, -0.73);
    comBorda(new THREE.Mesh(cabGeo, toon(0x27d6c4)), 0.02, 0.52, 0);
    const vidro = toon(0x0f1820, { emissive: 0x0a2a33, emissiveIntensity: 0.4 });
    const para = new THREE.Mesh(new THREE.BoxGeometry(0.08, 0.5, 1.3), vidro);
    para.position.set(1.21, 1.42, 0);
    para.rotation.z = -0.38;
    corpo.add(para);
    [-1, 1].forEach((lado) => {
      const j = new THREE.Mesh(new THREE.BoxGeometry(0.62, 0.42, 0.04), vidro);
      j.position.set(0.68, 1.44, lado * 0.77);
      corpo.add(j);
      const roda = new THREE.Mesh(new THREE.CylinderGeometry(0.06, 0.06, 0.02, 6), preto);
      roda.position.set(1.12, 1.32, lado * 0.84);
      corpo.add(roda);
    });
    const def = new THREE.Shape();
    def.moveTo(0, 0);
    def.lineTo(0.62, 0);
    def.quadraticCurveTo(0.2, 0.18, 0, 0.42);
    def.lineTo(0, 0);
    const defGeo = new THREE.ExtrudeGeometry(def, { depth: 1.3, bevelEnabled: false, curveSegments: 6 });
    defGeo.translate(0, 0, -0.65);
    comBorda(new THREE.Mesh(defGeo, toon(0x1ec8e6)), 0.04, 1.86, 0);
    const farol = new THREE.MeshBasicMaterial({ color: 0xfff6c8 });
    [-0.52, 0.52].forEach((z) => {
      const f = new THREE.Mesh(new THREE.BoxGeometry(0.06, 0.16, 0.26), farol);
      f.position.set(1.32, 0.86, z);
      corpo.add(f);
    });
    const cromo = toon(0xb4bec9);
    comBorda(new THREE.Mesh(new THREE.CylinderGeometry(0.07, 0.07, 1.6, 8), cromo), 0, 1.36, -0.66);

    // rodas (fora do corpo, para o corpo balancar sobre elas)
    const pneu = toon(0x1a2028);
    const calota = toon(0xdfe6ea);
    const rodas = [];
    [0.78, -1.55, -2.3].forEach((x) => {
      [-0.7, 0.7].forEach((z) => {
        const r = new THREE.Group();
        const pn = comBorda(new THREE.Mesh(new THREE.CylinderGeometry(0.36, 0.36, 0.3, 14), pneu), 0, 0, 0, r);
        pn.rotation.x = Math.PI / 2;
        const cl = new THREE.Mesh(new THREE.CylinderGeometry(0.16, 0.16, 0.32, 8), calota);
        cl.rotation.x = Math.PI / 2;
        r.add(cl);
        r.position.set(x, 0.36, z);
        raiz.add(r);
        rodas.push(r);
      });
    });

    const sombra = new THREE.Mesh(new THREE.CircleGeometry(1, 24), new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.42, depthWrite: false }));
    sombra.rotation.x = -Math.PI / 2;
    sombra.scale.set(2.7, 1.25, 1);
    sombra.position.set(-0.78, 0.02, 0);
    raiz.add(sombra);
    const anel = new THREE.Mesh(new THREE.RingGeometry(1.15, 1.42, 40), new THREE.MeshBasicMaterial({ color: 0x1ec8e6, transparent: true, opacity: 0.6, depthWrite: false, side: THREE.DoubleSide }));
    anel.rotation.x = -Math.PI / 2;
    anel.position.set(-0.78, 0.03, 0);
    raiz.add(anel);

    const fumacas = [];
    const fumacaGeo = new THREE.IcosahedronGeometry(0.22, 0);
    for (let i = 0; i < 6; i++) {
      const f = new THREE.Mesh(fumacaGeo, new THREE.MeshToonMaterial({ color: 0xeaf7f4, gradientMap: degraus, transparent: true, opacity: 0 }));
      f.visible = false;
      corpo.add(f);
      fumacas.push({ m: f, t0: -1 });
    }

    // o ponto do mapa fica no meio do caminhao, no chao
    raiz.children.forEach((c) => { c.position.x += 0.78; });

    let ultimo = 0;
    let proxFumaca = 0;
    return {
      raiz,
      comprimento: 4.4,
      anima(agora, andando, calmo) {
        const t = agora / 1000;
        const dt = ultimo ? Math.min(0.05, t - ultimo) : 0;
        ultimo = t;
        if (calmo) {
          corpo.position.y = 0;
          corpo.rotation.z = 0;
        } else {
          corpo.position.y = Math.sin(t * 15) * 0.018 + (andando ? Math.abs(Math.sin(t * 9)) * 0.07 : 0);
          corpo.rotation.z = andando ? Math.sin(t * 4.5) * 0.025 : Math.sin(t * 1.6) * 0.008;
          rodas.forEach((r) => { r.rotation.z -= dt * (andando ? 9 : 0); });
        }
        anel.scale.setScalar(1 + ((t * 0.6) % 1) * 0.5);
        anel.material.opacity = calmo ? 0.5 : 0.65 * (1 - ((t * 0.6) % 1));
        if (!calmo && t > proxFumaca) {
          proxFumaca = t + (andando ? 0.22 : 0.55);
          const livre = fumacas.find((f) => f.t0 < 0);
          if (livre) { livre.t0 = t; livre.m.visible = true; }
        }
        fumacas.forEach((f) => {
          if (f.t0 < 0) return;
          const v = (t - f.t0) / 1.3;
          if (v >= 1 || calmo) { f.t0 = -1; f.m.visible = false; return; }
          f.m.position.set(-v * (andando ? 1.8 : 0.5), 2.25 + v * 1.1, -0.66 - v * 0.2);
          f.m.scale.setScalar(0.6 + v * 1.6);
          f.m.material.opacity = 0.85 * (1 - v);
        });
      },
    };
  }

  async function abreMapa3d(vis) {
    const [mlMod, THREE, bruto] = await comTempo(carregaLibs(), 25000);
    if (vis.morto) return;
    const ml = mlMod.Map ? mlMod : mlMod.default;
    const estilo = recolore(JSON.parse(JSON.stringify(bruto)));
    const { envio, rota, fig, caixa } = vis;
    const celular = fig.clientWidth < 640;
    const map = new ml.Map({
      container: caixa,
      style: estilo,
      center: [desmerc(rota.pos).lng, desmerc(rota.pos).lat],
      zoom: 3.4,
      pitch: 0,
      bearing: 0,
      attributionControl: { compact: true },
      cooperativeGestures: true,
      locale: LOCALE,
      canvasContextAttributes: { antialias: true },
      fadeDuration: 0,
      maxPitch: 70,
      renderWorldCopies: false,
      pixelRatio: Math.min(window.devicePixelRatio || 1, 2),
    });
    vis.map = map;
    // o mapa e enfeite: tudo o que ele mostra esta escrito na pagina. sai da ordem do teclado e do leitor de tela
    // (os botoes de zoom e os creditos continuam acessiveis)
    map.getCanvas().setAttribute('tabindex', '-1');
    map.getCanvas().setAttribute('aria-hidden', 'true');
    await comTempo(new Promise((ok, nao) => {
      const aoErro = (e) => {
        if (e && (e.tile || e.sourceId)) return;
        if (!map.isStyleLoaded()) nao((e && e.error) || erro('estilo'));
      };
      map.on('error', aoErro);
      map.once('load', () => { map.off('error', aoErro); ok(); });
    }), 20000);
    if (vis.morto) { map.remove(); return; }

    const calmo = reduz();
    try { await comTempo(document.fonts.load('600 50px GeBody'), 1500); } catch (e) { /* segue com a fonte reserva */ }
    if (vis.morto) { map.remove(); return; }
    const primeiroSimbolo = (map.getStyle().layers.find((l) => l.type === 'symbol') || {}).id;
    const tamanho = celular ? 62 : 90;
    // folga do enquadramento: em cima o balao; embaixo a legenda e os creditos do mapa (abertos ate mexer no mapa)
    const folga = celular ? { top: 118, bottom: 196, left: 56, right: 56 } : { top: 150, bottom: 172, left: 80, right: 90 };
    // mesma cidade: zoom de cidade inteira
    const zoomCidade = celular ? 11.6 : 12.2;
    if (rota.mesma) rota.estaciona(512 * Math.pow(2, zoomCidade), tamanho);
    else if (rota.estaciona) {
      const pre = map.cameraForBounds(new ml.LngLatBounds([envio.origem.lng, envio.origem.lat], [envio.origem.lng, envio.origem.lat]).extend([envio.destino.lng, envio.destino.lat]), { padding: folga });
      if (pre) rota.estaciona(512 * Math.pow(2, pre.zoom + (celular ? 0.3 : 0.45)), tamanho);
    }
    const comLinha = !rota.mesma;
    const pinta = (fim) => {
      if (!comLinha) return;
      const f = Math.max(0.0005, fim);
      const g = (a, b) => (f >= 0.999 ? ['interpolate', ['linear'], ['line-progress'], 0, a, 1, b] : ['interpolate', ['linear'], ['line-progress'], 0, a, f, b, f + 0.0004, 'rgba(0,0,0,0)', 1, 'rgba(0,0,0,0)']);
      map.setPaintProperty('rast-feito-brilho', 'line-gradient', g('rgba(47,227,168,0.38)', 'rgba(30,200,230,0.45)'));
      map.setPaintProperty('rast-feito-borda', 'line-gradient', g('#05070a', '#05070a'));
      map.setPaintProperty('rast-feito', 'line-gradient', g('#2fe3a8', '#1ec8e6'));
    };
    const comFalta = comLinha && !rota.semFalta;
    if (comLinha) {
      if (comFalta) map.addSource('rast-falta', { type: 'geojson', data: geo(rota.falta.length > 1 ? rota.falta : [rota.pos, rota.pos]) });
      map.addSource('rast-feito', { type: 'geojson', lineMetrics: true, data: geo(rota.feito.pts) });
      if (comFalta) map.addLayer({ id: 'rast-falta', type: 'line', source: 'rast-falta', layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-color': '#eaf7f4', 'line-width': 3, 'line-dasharray': [0.6, 2.4], 'line-opacity': calmo ? 0.6 : 0, 'line-opacity-transition': { duration: 700, delay: 0 } } }, primeiroSimbolo);
      map.addLayer({ id: 'rast-feito-brilho', type: 'line', source: 'rast-feito', layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-width': 22, 'line-blur': 14, 'line-gradient': ['interpolate', ['linear'], ['line-progress'], 0, '#2fe3a8', 1, '#1ec8e6'] } }, primeiroSimbolo);
      map.addLayer({ id: 'rast-feito-borda', type: 'line', source: 'rast-feito', layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-width': 11, 'line-gradient': ['interpolate', ['linear'], ['line-progress'], 0, '#05070a', 1, '#05070a'] } }, primeiroSimbolo);
      map.addLayer({ id: 'rast-feito', type: 'line', source: 'rast-feito', layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-width': 5.5, 'line-gradient': ['interpolate', ['linear'], ['line-progress'], 0, '#2fe3a8', 1, '#1ec8e6'] } }, primeiroSimbolo);
    }
    // cidades por onde o pacote passou: bolinhas brancas de contorno preto em cima do caminho
    if (rota.paradas && rota.paradas.length) {
      map.addSource('rast-paradas', { type: 'geojson', data: { type: 'FeatureCollection', features: rota.paradas.map((p) => ({ type: 'Feature', properties: {}, geometry: { type: 'Point', coordinates: [p.lng, p.lat] } })) } });
      map.addLayer({ id: 'rast-paradas', type: 'circle', source: 'rast-paradas', paint: { 'circle-radius': 5.5, 'circle-color': '#eaf7f4', 'circle-stroke-color': '#05070a', 'circle-stroke-width': 3, 'circle-pitch-alignment': 'map' } }, primeiroSimbolo);
    }

    const pino = (elm, ll) => {
      elm.setAttribute('aria-hidden', 'true');
      const m = new ml.Marker({ element: elm, anchor: 'bottom' }).setLngLat(ll).addTo(map);
      vis.marcas.push(m);
      return elm;
    };
    const o = envio.origem;
    const d = envio.destino;
    // mesma cidade: a loja e a casa cairiam no mesmo ponto; fica so a casa
    const pinos = [rota.mesma ? null : pino(marcaLoja(vis.textos, envio), [o.lng, o.lat]), pino(marcaCasa(envio), [d.lng, d.lat])];
    const bolhaEl = bolha(vis.rosto, vis.frase);
    bolhaEl.setAttribute('aria-hidden', 'true');
    const bolhaM = new ml.Marker({ element: bolhaEl, anchor: 'bottom', offset: [0, -tamanho * 0.62] }).setLngLat([desmerc(rota.pos).lng, desmerc(rota.pos).lat]).addTo(map);
    vis.marcas.push(bolhaM);
    const ajusta = () => {
      const pt = map.project([atual.ll.lng, atual.ll.lat]);
      const t = tamanho;
      arruma({ ancora: bolhaEl, x: pt.x, y: pt.y - t * 0.62, pinos, caixa, carro: { l: pt.x - t * 0.6, r: pt.x + t * 0.6, t: pt.y - t * 0.75, b: pt.y + t * 0.25 }, podeVirar: !estado.andando });
    };

    const estado = { f: calmo ? 1 : 0, andando: false, visivel: true };
    const posEm = (f) => {
      const p = aoLongo(rota.feito, f * rota.paraEm);
      let dx = p.dx;
      let dy = p.dy;
      if (Math.hypot(dx, dy) < 1e-12) { dx = rota.pos.dx; dy = rota.pos.dy; }
      if (Math.hypot(dx, dy) < 1e-12) { dx = 1; dy = 0; }
      return { ll: desmerc(p), rumo: Math.atan2(-dy, dx) };
    };
    let atual = posEm(estado.f);
    const modelo = montaCaminhao(THREE);
    const rotX = new THREE.Matrix4().makeRotationX(Math.PI / 2);
    let renderer;
    let cena;
    let camera;
    map.addLayer({
      id: 'rast-caminhao',
      type: 'custom',
      renderingMode: '3d',
      onAdd(m, gl) {
        camera = new THREE.Camera();
        cena = new THREE.Scene();
        cena.add(new THREE.HemisphereLight(0xffffff, 0x2a4450, 2.2));
        const sol = new THREE.DirectionalLight(0xffffff, 2.4);
        sol.position.set(2, 6, 3);
        cena.add(sol);
        cena.add(modelo.raiz);
        renderer = new THREE.WebGLRenderer({ canvas: m.getCanvas(), context: gl, antialias: true });
        renderer.autoClear = false;
      },
      render(gl, args) {
        const z = map.getZoom();
        const s = tamanho / modelo.comprimento / (512 * Math.pow(2, z));
        const mc = ml.MercatorCoordinate.fromLngLat([atual.ll.lng, atual.ll.lat], 0);
        const mat = new THREE.Matrix4().fromArray(args.defaultProjectionData.mainMatrix);
        const l = new THREE.Matrix4().makeTranslation(mc.x, mc.y, mc.z).scale(new THREE.Vector3(s, -s, s)).multiply(rotX).multiply(new THREE.Matrix4().makeRotationY(atual.rumo));
        camera.projectionMatrix = mat.multiply(l);
        modelo.anima(performance.now(), estado.andando, calmo);
        renderer.resetState();
        renderer.render(cena, camera);
      },
      onRemove() {
        if (renderer) renderer.dispose();
      },
    });

    // enquadramento: a rota inteira, inclinada; no celular menos inclinada para caber
    const pts = [[o.lng, o.lat], [d.lng, d.lat], [atual.ll.lng, atual.ll.lat]];
    const caixaB = pts.reduce((b, p) => b.extend(p), new ml.LngLatBounds(pts[0], pts[0]));
    const pitch = celular ? 42 : 50;
    // gira o mapa a favor da rota, que corre para o lado (o balao fica em cima do caminhao sem cobrir o caminho),
    // sem passar de uns 20 graus para o brasil continuar com cara de brasil
    let giro = rota.rumo - 90;
    while (giro > 90) giro -= 180;
    while (giro < -90) giro += 180;
    const bearing = Math.max(-26, Math.min(26, giro)) * 0.8;
    // enquadra sem inclinar e aproxima um pouco: inclinado, o fundo do mapa encolhe e sobra espaco
    const quadro = () => {
      if (rota.mesma) {
        const D = merc(d);
        return { center: desmerc({ x: rota.pos.x + (D.x - rota.pos.x) * (celular ? 0.15 : 0.5), y: D.y }), zoom: zoomCidade };
      }
      const c = map.cameraForBounds(caixaB, { padding: folga, bearing, maxZoom: 8 });
      if (!c) return { center: map.getCenter(), zoom: 4 };
      return { center: c.center, zoom: Math.min(8, c.zoom + (celular ? 0.3 : 0.45)) };
    };
    vis.recentra = () => { const c = quadro(); map.easeTo(Object.assign({}, c, { pitch, bearing, duration: calmo ? 0 : 1200 })); };
    const fim = quadro();
    // perto da saida, o pino da loja (por cima do mapa) cobriria o caminhao: mede no quadro final, ja inclinado, e
    // se precisar o caminhao para mais adiante na rota
    if (pinos[0]) {
      map.jumpTo(Object.assign({}, fim, { pitch, bearing }));
      const cab = pinos[0].querySelector('.s-rast__pin-cabeca');
      const pino = cabecaPino(map.project([o.lng, o.lat]), cab.offsetWidth || 50, parseFloat(getComputedStyle(cab).marginBottom) || 0);
      const t = tamanho;
      afastaDaLoja(rota, (q) => map.project(desmerc(q)), pino, (p) => ({ l: p.x - t * 0.6, r: p.x + t * 0.6, t: p.y - t * 0.75, b: p.y + t * 0.35 }));
      map.getSource('rast-feito').setData(geo(rota.feito.pts));
      if (comFalta) map.getSource('rast-falta').setData(geo(rota.falta.length > 1 ? rota.falta : [rota.pos, rota.pos]));
      atual = posEm(estado.f);
      bolhaM.setLngLat([atual.ll.lng, atual.ll.lat]);
    }
    map.on('moveend', ajusta);
    if (calmo) {
      map.jumpTo(Object.assign({}, fim, { pitch, bearing }));
    } else {
      map.jumpTo({ center: fim.center, zoom: fim.zoom - 0.7, pitch: 0, bearing: 0 });
      map.easeTo(Object.assign({}, fim, { pitch, bearing, duration: 3000, easing: suave }));
    }

    fig.classList.add('is-gl');
    vis.ctrl.hidden = false;
    // ganchos para conferencia (prints automaticos): o mapa e a posicao do caminhao
    fig.ntRast = { map, ml, pos: () => atual, quadro };
    // a primeira volta: a linha se desenha da loja ate o caminhao e ele vai junto
    const inicio = performance.now();
    const DURA = 2800;
    if (!calmo) pinta(0.0005);
    bolhaEl.classList.add('is-escondida');
    setTimeout(() => bolhaEl.classList.remove('is-escondida'), calmo ? 0 : 900);
    let quadroN = 0;
    const laco = (agora) => {
      if (vis.morto) return;
      vis.raf = 0;
      if (estado.f < 1 && !calmo) {
        const v = Math.min(1, (agora - inicio) / DURA);
        estado.f = suave(v);
        estado.andando = v < 1;
        atual = posEm(estado.f);
        bolhaM.setLngLat([atual.ll.lng, atual.ll.lat]);
        if (quadroN % 2 === 0 || v >= 1) { pinta(estado.f); ajusta(); }
        if (v >= 1 && comFalta) map.setPaintProperty('rast-falta', 'line-opacity', 0.6);
      }
      if (estado.andando || quadroN++ % 2 === 0) map.triggerRepaint();
      if (estado.visivel && !document.hidden && !calmo) vis.raf = requestAnimationFrame(laco);
    };
    vis.retoma = () => { if (!vis.raf && !vis.morto && !calmo) vis.raf = requestAnimationFrame(laco); };
    ajusta();
    if (calmo) { pinta(1); map.triggerRepaint(); } else vis.raf = requestAnimationFrame(laco);
    vis.observa = new IntersectionObserver((ents) => {
      estado.visivel = ents[0].isIntersecting;
      if (estado.visivel) vis.retoma();
    });
    vis.observa.observe(fig);
    vis.aoVoltar = () => { if (!document.hidden) vis.retoma(); };
    document.addEventListener('visibilitychange', vis.aoVoltar);
  }

  /* ---------- a pagina ---------- */
  const TEXTO_AVISO = {
    nao_encontrado: {
      tit: 'Não achei esse pedido',
      txt: 'Confira o código e tente de novo.',
      txtPedido: 'Confira o código (ou o número do pedido e o e-mail) e tente de novo.',
      dicas: ['Copie o código direto do e-mail de envio do pedido e cole aqui, do jeito que veio.', 'Depois de postado, a transportadora pode levar até 1 dia útil para mostrar o pacote.'],
      dicaPedido: 'Acabou de comprar? Busque pelo número do pedido.',
    },
    aguardando_postagem: {
      tit: 'Seu pedido está sendo preparado',
      txt: 'Ele ainda não foi postado. Assim que a etiqueta entrar na transportadora, o caminho aparece aqui.',
      dicas: ['Você recebe o código por e-mail quando ele sair daqui.'],
    },
    limite: { tit: 'Calma, muita busca seguida', txt: 'Espere um minutinho e tente de novo.', dicas: [] },
    indisponivel: { tit: 'Não deu para consultar agora', txt: 'O sistema da transportadora não respondeu. Tente de novo daqui a pouco.', dicas: [] },
  };
  const ERRO_CAMPO = {
    codigo: 'Confira o código: são de 6 a 40 letras e números, com pelo menos um número.',
    cpf: 'Isso parece um CPF. O código de rastreio é outro: ele chega no e-mail de envio do pedido.',
    pedido: 'Confira o número do pedido: só os números, como 1234.',
    email: 'Confira o e-mail da compra.',
    dados_invalidos: 'Algum dado não bateu. Confira e tente de novo.',
  };

  function iniciar(raiz) {
    if (raiz.ntRast) return;
    raiz.ntRast = true;
    const q = (s) => raiz.querySelector(s);
    const qq = (s) => Array.from(raiz.querySelectorAll(s));
    let textos = {};
    try { textos = JSON.parse((q('[data-rast-textos]') || {}).textContent || '{}'); } catch (e) { textos = {}; }
    textos.msg = textos.msg || {};
    const o = textos.origem || {};
    textos.origem = Object.assign(lugar({ cidade: o.cidade || "Santa Bárbara d'Oeste", uf: o.uf || 'SP', lat: o.lat || -22.8006, lng: o.lng || -47.4281 }), { nome: o.nome || 'NOVATRACKERS' });

    const endpoint = (raiz.getAttribute('data-endpoint') || '').trim();
    const rosto = raiz.getAttribute('data-rosto') || '';
    const comMapa = raiz.getAttribute('data-mapa') !== '0';
    const form = q('[data-rast-form]');
    const res = q('[data-rast-res]');
    const vivo = q('[data-rast-vivo]');
    const erroEl = q('[data-rast-erro]');
    const params = new URLSearchParams(window.location.search);
    const demoParam = params.get('demo');
    const demo = demoParam != null || !endpoint;
    const estado = { resposta: null, idx: 0, vis: null, etapaDemo: null, buscando: false };

    const painel = (nome) => qq('[data-rast-painel]').forEach((p) => { p.hidden = p.getAttribute('data-rast-painel') !== nome; });
    const anuncia = (t) => { vivo.textContent = ''; setTimeout(() => { vivo.textContent = t; }, 60); };
    const rola = () => {
      const alvo = res.getBoundingClientRect().top;
      if (alvo > window.innerHeight * 0.6 || alvo < 0) res.scrollIntoView({ behavior: reduz() ? 'auto' : 'smooth', block: 'start' });
    };

    const modo = () => { const r = q('[data-rast-modo]:checked'); return r ? r.value : 'codigo'; };
    const trocaModo = () => {
      const m = modo();
      qq('[data-rast-grupo]').forEach((g) => {
        const liga = g.getAttribute('data-rast-grupo') === m;
        g.hidden = !liga;
        g.querySelectorAll('input').forEach((i) => { i.disabled = !liga; });
      });
      limpaErro();
    };
    qq('[data-rast-modo]').forEach((r) => r.addEventListener('change', trocaModo));

    function limpaErro() {
      erroEl.hidden = true;
      erroEl.textContent = '';
      qq('[data-rast-campo]').forEach((i) => i.removeAttribute('aria-invalid'));
    }
    function erroCampo(campo, msg, foco = true) {
      erroEl.textContent = msg;
      erroEl.hidden = false;
      if (campo) {
        campo.setAttribute('aria-invalid', 'true');
        if (foco) campo.focus();
      }
    }

    function buscando(sim) {
      estado.buscando = sim;
      form.classList.toggle('is-buscando', sim);
      const b = q('[data-rast-enviar]');
      b.setAttribute('aria-busy', sim ? 'true' : 'false');
    }

    async function envia(corpo, opcoes) {
      if (estado.buscando) return;
      buscando(true);
      fechaMapa();
      painel('carregando');
      rola();
      anuncia('Procurando seu pedido.');
      try {
        let resposta;
        if (demo) {
          await espera(reduz() ? 200 : 1100);
          resposta = amostra(estado.etapaDemo || etapaDaUrl(), textos.origem, corpo.codigo || '');
        } else {
          resposta = await consulta(endpoint, corpo);
        }
        if (resposta && resposta.ok === false) throw erro(resposta.erro);
        const n = normaliza(resposta, { origem: textos.origem, codigo: corpo.codigo });
        estado.resposta = n;
        estado.idx = 0;
        mostra(true, opcoes.foco !== false);
      } catch (e) {
        const cod = (e && e.cod) || 'indisponivel';
        if (cod === 'dados_invalidos' || cod === 'busca_por_pedido_indisponivel') {
          // o servico recusou o que foi digitado: um resultado anterior seria de outro codigo, entao volta o mapa vazio
          estado.resposta = null;
          mostraVazio();
          erroCampo(form.querySelector('[data-rast-campo]:not([disabled])'), (e && e.mensagem) || ERRO_CAMPO.dados_invalidos, opcoes.foco !== false);
        } else {
          aviso(cod);
        }
      } finally {
        buscando(false);
      }
    }

    // a busca pelo pedido pode estar desligada na secao: os avisos so falam dela quando ela existe
    const comPedido = !!q('[data-rast-modo]');
    function aviso(cod) {
      const base = TEXTO_AVISO[cod] || TEXTO_AVISO.indisponivel;
      const t = Object.assign({}, base, {
        txt: comPedido && base.txtPedido ? base.txtPedido : base.txt,
        dicas: base.dicas.concat(comPedido && base.dicaPedido ? [base.dicaPedido] : []),
      });
      const p = q('[data-rast-painel="aviso"]');
      p.setAttribute('data-cod', cod);
      q('[data-rast-aviso-tit]').textContent = t.tit;
      q('[data-rast-aviso-txt]').textContent = t.txt;
      const ul = q('[data-rast-aviso-dicas]');
      ul.textContent = '';
      t.dicas.forEach((d) => ul.appendChild(el('li', null, d)));
      ul.hidden = !t.dicas.length;
      painel('aviso');
      anuncia(`${t.tit}. ${t.txt}`);
      q('[data-rast-aviso-tit]').focus({ preventScroll: true });
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      limpaErro();
      if (modo() === 'pedido') {
        const pi = q('[data-rast-campo="pedido"]');
        const ei = q('[data-rast-campo="email"]');
        const pedido = pi.value.replace(/[\s#]/g, '');
        const email = ei.value.trim();
        if (!/^\d{3,10}$/.test(pedido)) return erroCampo(pi, ERRO_CAMPO.pedido);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return erroCampo(ei, ERRO_CAMPO.email);
        return envia({ pedido: `#${pedido}`, email }, {});
      }
      const ci = q('[data-rast-campo="codigo"]');
      if (pareceCpf(ci.value)) return erroCampo(ci, ERRO_CAMPO.cpf);
      const codigo = limpaCodigo(ci.value);
      ci.value = codigo;
      if (!codigoOk(codigo)) return erroCampo(ci, ERRO_CAMPO.codigo);
      return envia({ codigo }, {});
    });
    qq('[data-rast-campo]').forEach((i) => i.addEventListener('input', () => { if (!erroEl.hidden) limpaErro(); }));
    // o # ja esta desenhado no campo: so numeros
    const pedidoCampo = q('[data-rast-campo="pedido"]');
    if (pedidoCampo) pedidoCampo.addEventListener('input', () => { const v = pedidoCampo.value.replace(/\D+/g, ''); if (v !== pedidoCampo.value) pedidoCampo.value = v; });
    q('[data-rast-de-novo]').addEventListener('click', () => {
      const alvo = form.querySelector('[data-rast-campo]:not([disabled])');
      form.scrollIntoView({ behavior: reduz() ? 'auto' : 'smooth', block: 'center' });
      if (alvo) setTimeout(() => alvo.focus({ preventScroll: true }), reduz() ? 0 : 450);
    });

    function fechaMapa() {
      const v = estado.vis;
      if (!v) return;
      v.morto = true;
      if (v.raf) cancelAnimationFrame(v.raf);
      if (v.observa) v.observa.disconnect();
      if (v.observaVer) v.observaVer.disconnect();
      if (v.ro) v.ro.disconnect();
      if (v.aoVoltar) document.removeEventListener('visibilitychange', v.aoVoltar);
      v.marcas.forEach((m) => m.remove());
      if (v.map) { try { v.map.remove(); } catch (e) { /* mapa ja saiu */ } }
      v.fig.classList.remove('is-gl', 'is-svg');
      v.caixa.textContent = '';
      v.svgBox.textContent = '';
      v.ctrl.hidden = true;
      estado.vis = null;
    }

    function mostra(rolar, foco = rolar) {
      const n = estado.resposta;
      const envio = n.envios[estado.idx];
      painel('resultado');
      const p = q('[data-rast-painel="resultado"]');
      p.setAttribute('data-etapa', envio.etapa);
      p.classList.toggle('is-alerta', envio.alerta);

      const demoBox = q('[data-rast-demo]');
      demoBox.hidden = !demo;
      qq('[data-rast-demo-etapa]').forEach((b) => b.setAttribute('aria-pressed', String(b.getAttribute('data-rast-demo-etapa') === envio.etapa)));

      const pac = q('[data-rast-pacotes]');
      pac.textContent = '';
      pac.hidden = n.envios.length < 2;
      if (n.envios.length > 1) {
        n.envios.forEach((e, i) => {
          const b = el('button', 'fx-chip fx-chip--escuro', `Pacote ${i + 1}${e.transportadora.nome ? ' · ' + e.transportadora.nome : ''}`);
          b.type = 'button';
          b.setAttribute('aria-pressed', String(i === estado.idx));
          b.addEventListener('click', () => { if (i !== estado.idx) { estado.idx = i; fechaMapa(); mostra(false); } });
          pac.appendChild(b);
        });
      }

      const rotulo = envio.rotulo || ROTULO[envio.etapa] || ROTULO.sem_info;
      const st = q('[data-rast-status]');
      st.textContent = rotulo;
      st.setAttribute('data-texto', rotulo);
      st.style.setProperty('--d', String(Math.max(6, rotulo.length)));
      const frase = textos.msg[envio.etapa] || '';
      q('[data-rast-frase]').textContent = frase;
      const transp = [envio.transportadora.nome, envio.transportadora.servico].filter(Boolean).join(' · ');
      q('[data-rast-transp]').textContent = transp || 'A confirmar';
      q('[data-rast-codigo]').textContent = envio.codigo || (n.pedido ? `Pedido ${n.pedido}` : '');
      q('[data-rast-copiar]').hidden = !envio.codigo;
      q('[data-rast-atualizado]').textContent = quando(envio.atualizado) || 'agora';

      q('[data-rast-de]').textContent = nomeLugar(envio.origem);
      q('[data-rast-para]').textContent = nomeLugar(envio.destino) || 'seu endereço';
      const deIco = q('[data-rast-de-ico]');
      const outra = origemOutra(textos, envio);
      deIco.classList.toggle('is-outra', outra);
      deIco.innerHTML = icoOrigem(outra);
      const rota = montaRota(envio);
      const kmEl = q('[data-rast-km]');
      // mesma cidade: a legenda mostra a cidade uma vez so, com o aviso do lado
      q('.s-rast__legenda').classList.toggle('is-mesma', !!(rota && rota.mesma));
      if (rota && rota.mesma) kmEl.textContent = textos.mesma || 'Entrega na mesma cidade';
      // cancelado: o pacote nao segue, entao nao tem quanto falta
      else if (rota && envio.etapa !== 'cancelado') {
        kmEl.textContent = envio.etapa === 'entregue' ? `${milhar(rota.total)} km rodados` : rota.resto > 30 ? `faltam ≈ ${milhar(rota.resto)} km` : 'quase lá!';
      } else kmEl.textContent = '';

      desenhaEta(envio);
      desenhaTrilha(envio);
      desenhaEventos(envio);

      const link = q('[data-rast-link]');
      link.hidden = !envio.link;
      if (envio.link) link.href = envio.link;

      abreMapa(envio, rota, frase);

      const prev = envio.previsao.de ? textoPrevisao(envio) : '';
      anuncia(`Pedido encontrado. ${rotulo}. ${frase} ${prev}`.trim());
      if (rolar) rola();
      if (foco) {
        const h = q('.s-rast__status');
        if (h) h.focus({ preventScroll: true });
      }
    }

    function textoPrevisao(envio) {
      const { de, ate } = envio.previsao;
      if (!de) return '';
      const um = (d) => `${F.semLonga.format(d)}, ${F.dia.format(d)} de ${F.mesLongo.format(d)}`;
      return diaSP(de) === diaSP(ate) ? `Previsão de entrega: ${um(de)}.` : `Previsão de entrega: entre ${um(de)} e ${um(ate)}.`;
    }

    function folha(d, extra) {
      const f = el('span', 's-rast__folha' + (extra ? ' ' + extra : ''));
      f.setAttribute('aria-hidden', 'true');
      f.appendChild(el('span', 's-rast__folha-sem', limpo(F.sem.format(d))));
      f.appendChild(el('span', 's-rast__folha-dia', F.dia.format(d)));
      f.appendChild(el('span', 's-rast__folha-mes', limpo(F.mes.format(d))));
      return f;
    }

    const etaTitulo = q('[data-rast-eta-tit]').textContent;
    function desenhaEta(envio) {
      const box = q('[data-rast-eta-datas]');
      const nota = q('[data-rast-eta-nota]');
      const tit = q('[data-rast-eta-tit]');
      box.textContent = '';
      nota.textContent = '';
      nota.className = 's-rast__eta-nota';
      const hoje = diaSP(new Date());
      if (envio.etapa === 'entregue' && envio.entregueEm) {
        tit.textContent = 'Entregue em';
        box.appendChild(folha(envio.entregueEm, 's-rast__folha--ok'));
        const selo = el('span', 's-rast__eta-ok');
        selo.innerHTML = svgUso('i-ok', 'stroke="currentColor" stroke-width="3"');
        box.appendChild(selo);
        box.appendChild(el('span', 'vh', `${F.semLonga.format(envio.entregueEm)}, ${F.dia.format(envio.entregueEm)} de ${F.mesLongo.format(envio.entregueEm)}`));
        nota.textContent = `Às ${F.hora.format(envio.entregueEm)}${envio.destino ? ', em ' + nomeLugar(envio.destino) : ''}.`;
        // entregue: o mascote deitado, de pernas para o ar, no canto do cartao
        const deitado = raiz.getAttribute('data-deitado');
        if (deitado) {
          const img = el('img', 's-rast__eta-deitado');
          img.src = deitado;
          img.alt = '';
          img.width = 480;
          img.height = 170;
          img.decoding = 'async';
          box.appendChild(img);
        }
        return;
      }
      tit.textContent = etaTitulo;
      if (envio.etapa === 'cancelado') {
        box.appendChild(el('span', 's-rast__folha s-rast__folha--vazia', '×'));
        nota.textContent = 'Sem previsão: esse envio foi cancelado. Se não era para ser, fala com a gente.';
        return;
      }
      const { de, ate } = envio.previsao;
      if (!de) {
        box.appendChild(el('span', 's-rast__folha s-rast__folha--vazia', '?'));
        nota.textContent = envio.alerta ? 'A previsão volta quando a transportadora resolver o problema.' : 'A transportadora ainda não informou a previsão. Ela aparece aqui assim que sair.';
        return;
      }
      const mesmo = diaSP(de) === diaSP(ate);
      box.appendChild(folha(de));
      if (!mesmo) {
        const seta = el('span', 's-rast__eta-seta');
        seta.innerHTML = svgUso('i-seta', 'stroke="currentColor" stroke-width="2.8"');
        box.appendChild(seta);
        box.appendChild(folha(ate));
      }
      box.appendChild(el('span', 'vh', textoPrevisao(envio)));
      const a = diaSP(de) - hoje;
      const b = diaSP(ate) - hoje;
      let t;
      if (envio.alerta) t = 'Pode atrasar: veja o que a transportadora informou no histórico.';
      else if (b < 0) t = 'A previsão já passou. Pode ser atraso na transportadora: acompanhe por aqui.';
      else if (envio.etapa === 'saiu' || (a <= 0 && b === 0)) t = 'Chega hoje!';
      else if (a <= 0) t = `Pode chegar hoje. No máximo em ${b} ${b === 1 ? 'dia' : 'dias'}.`;
      else if (a === b) t = a === 1 ? 'Chega amanhã!' : `Faltam ${a} dias.`;
      else t = a === 1 ? `Chega a partir de amanhã, em até ${b} dias.` : `Faltam de ${a} a ${b} dias.`;
      nota.textContent = t;
      if (!envio.alerta && b >= 0 && a <= 1) nota.classList.add('is-quente');
    }

    function desenhaTrilha(envio) {
      const trilha = q('[data-rast-trilha]');
      const passo = envio.passo || 0;
      trilha.style.setProperty('--p', String(Math.max(0, Math.min(1, (passo - 1) / 3))));
      trilha.classList.toggle('is-alerta', envio.alerta);
      // data em que cada etapa foi alcancada: o primeiro evento daquela etapa ou de uma depois dela
      const datas = [null, null, null, null, null];
      envio.eventos.slice().reverse().forEach((ev) => {
        const p = PASSO[ev.etapa];
        if (p == null || !ev.data) return;
        for (let i = 1; i <= p; i++) if (!datas[i]) datas[i] = ev.data;
      });
      qq('[data-rast-passo]').forEach((li) => {
        const i = Number(li.getAttribute('data-rast-passo'));
        const feito = i <= passo;
        const agora = i === passo || (passo === 0 && i === 1);
        li.classList.toggle('is-feito', feito);
        li.classList.toggle('is-atual', agora);
        li.classList.toggle('is-problema', envio.alerta && i === Math.min(4, passo + 1));
        const dEl = li.querySelector('[data-rast-passo-data]');
        dEl.textContent = feito && datas[i] ? diaMes(datas[i]) : '';
        li.querySelector('[data-rast-passo-estado]').textContent = feito ? (i === passo ? ', etapa atual' : ', concluída') : ', pendente';
        if (agora) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      });
    }

    const LIMITE = 5;
    function desenhaEventos(envio) {
      const ol = q('[data-rast-eventos]');
      const mais = q('[data-rast-mais]');
      ol.textContent = '';
      const evs = envio.eventos;
      q('[data-rast-hist-qtd]').textContent = evs.length ? `${evs.length} ${evs.length === 1 ? 'movimentação' : 'movimentações'}` : '';
      if (!evs.length) {
        const li = el('li', 's-rast__ev s-rast__ev--vazio');
        li.appendChild(el('p', 's-rast__ev-desc', 'Sem movimentações ainda. Assim que a transportadora registrar o pacote, o caminho aparece aqui.'));
        ol.appendChild(li);
      }
      evs.forEach((ev, i) => {
        const li = el('li', `s-rast__ev is-${ev.etapa || 'outro'}${i === 0 ? ' is-agora' : ''}`);
        if (i >= LIMITE) li.hidden = true;
        const t = el('time', 's-rast__ev-quando');
        if (ev.data) {
          t.dateTime = ev.data.toISOString();
          t.appendChild(el('span', 's-rast__ev-dia', diaMes(ev.data)));
          t.appendChild(el('span', 's-rast__ev-hora', F.hora.format(ev.data)));
        }
        li.appendChild(t);
        const ponto = el('span', 's-rast__ev-ponto');
        ponto.setAttribute('aria-hidden', 'true');
        li.appendChild(ponto);
        const txt = el('div', 's-rast__ev-txt');
        if (i === 0) txt.appendChild(el('span', 's-rast__ev-novo', 'Mais recente'));
        txt.appendChild(el('p', 's-rast__ev-desc', ev.descricao || ROTULO[ev.etapa] || ''));
        if (ev.local) {
          const loc = el('p', 's-rast__ev-local');
          loc.innerHTML = svgUso('rast-i-pino', 'stroke="currentColor" stroke-width="2.2"');
          loc.appendChild(document.createTextNode(ev.local));
          txt.appendChild(loc);
        }
        li.appendChild(txt);
        ol.appendChild(li);
      });
      mais.hidden = evs.length <= LIMITE;
      mais.setAttribute('aria-expanded', 'false');
      const mt = q('[data-rast-mais-txt]');
      mt.textContent = mt.getAttribute('data-mais');
    }
    q('[data-rast-mais]').addEventListener('click', (e) => {
      const b = e.currentTarget;
      const abre = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', String(abre));
      qq('[data-rast-eventos] > li').forEach((li, i) => { if (i >= LIMITE) li.hidden = !abre; });
      const mt = q('[data-rast-mais-txt]');
      mt.textContent = mt.getAttribute(abre ? 'data-menos' : 'data-mais');
    });

    q('[data-rast-copiar]').addEventListener('click', (e) => {
      const b = e.currentTarget;
      const valor = q('[data-rast-codigo]').textContent.trim();
      const ok = () => {
        clearTimeout(b.ntVolta);
        b.classList.add('is-copiado');
        q('[data-rast-copiar-rotulo]').textContent = b.getAttribute('data-copiado');
        b.ntVolta = setTimeout(() => {
          b.classList.remove('is-copiado');
          q('[data-rast-copiar-rotulo]').textContent = b.getAttribute('data-copiar');
        }, 2000);
      };
      const plano = () => {
        const sel = window.getSelection();
        const faixa = document.createRange();
        faixa.selectNodeContents(q('[data-rast-codigo]'));
        sel.removeAllRanges();
        sel.addRange(faixa);
        try { if (document.execCommand('copy')) ok(); } catch (err) { /* o texto fica selecionado */ }
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(valor).then(ok, plano);
      else plano();
    });

    /* exemplo em outras etapas */
    qq('[data-rast-demo-etapa]').forEach((b) => b.addEventListener('click', () => {
      estado.etapaDemo = b.getAttribute('data-rast-demo-etapa');
      fechaMapa();
      estado.resposta = normaliza(amostra(estado.etapaDemo, textos.origem, (estado.resposta && estado.resposta.envios[0].codigo) || ''), { origem: textos.origem });
      estado.idx = 0;
      mostra(false);
    }));

    /* mapa: desenho na hora; o 3d quando aparecer na tela */
    const fig = q('[data-rast-mapa]');
    const caixa = q('[data-rast-gl]');
    const svgBox = q('[data-rast-svg]');
    const ctrl = q('[data-rast-ctrl]');
    ctrl.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      const v = estado.vis;
      if (!b || !v || !v.map) return;
      if (b.hasAttribute('data-rast-recentrar')) v.recentra();
      else if (Number(b.getAttribute('data-rast-zoom')) > 0) v.map.zoomIn();
      else v.map.zoomOut();
    });

    function desenha2d(vis) {
      const r = desenhaSvg(vis.svgBox, vis.envio, vis.rota, textos, {});
      vis.marcas2d.forEach((m) => m.remove());
      vis.marcas2d = [];
      const poe = (m, p, cls) => {
        if (!p) return null;
        m.classList.add('s-rast__no-svg', cls);
        m.style.left = `${(p.x / r.W) * 100}%`;
        m.style.top = `${(p.y / r.H) * 100}%`;
        vis.svgBox.appendChild(m);
        vis.marcas2d.push(m);
        return m;
      };
      const pinos = [poe(marcaLoja(textos, vis.envio), r.origemPx, 's-rast__no-svg--pino'), poe(marcaCasa(vis.envio), r.destinoPx, 's-rast__no-svg--pino')];
      if (r.posPx) {
        const cam = poe(caminhao2d(vis.rota.pos.dx >= 0), r.posPx, 's-rast__no-svg--cam');
        const b = bolha(rosto, vis.frase);
        poe(b, r.posPx, 's-rast__no-svg--bolha');
        const k = vis.svgBox.clientWidth / r.W;
        const cb = cam.getBoundingClientRect();
        const bx = vis.svgBox.getBoundingClientRect();
        arruma({ ancora: b, x: r.posPx.x * k, y: r.posPx.y * k - (vis.svgBox.clientWidth < 640 ? 36 : 46), pinos, caixa: vis.svgBox, carro: { l: cb.left - bx.left, r: cb.right - bx.left, t: cb.top - bx.top, b: cb.bottom - bx.top }, podeVirar: true });
      }
      vis.fig.classList.add('is-svg');
    }

    function abreMapa(envio, rota, frase) {
      fechaMapa();
      fig.hidden = !rota;
      q('.s-rast__grade').classList.toggle('is-sem-mapa', !rota);
      if (!rota) return;
      const vis = { fig, caixa, svgBox, ctrl, envio, rota, frase, textos, rosto, marcas: [], marcas2d: [], morto: false };
      estado.vis = vis;
      desenha2d(vis);
      let largura = fig.clientWidth;
      vis.ro = new ResizeObserver(() => {
        if (vis.morto || Math.abs(fig.clientWidth - largura) < 2) return;
        largura = fig.clientWidth;
        if (!fig.classList.contains('is-gl')) desenha2d(vis);
      });
      vis.ro.observe(fig);
      const economia = navigator.connection && navigator.connection.saveData;
      if (!comMapa || economia || !temWebgl()) return;
      vis.observaVer = new IntersectionObserver((ents) => {
        if (!ents[0].isIntersecting) return;
        vis.observaVer.disconnect();
        fig.classList.add('is-carregando');
        abreMapa3d(vis).catch((e) => {
          if (window.console) console.warn('[rastreio] mapa 3d indisponivel, fica o desenho', e);
          if (vis.map) { try { vis.map.remove(); } catch (err) { /* ja saiu */ } vis.map = null; }
          vis.marcas.forEach((m) => m.remove());
          vis.marcas = [];
          fig.classList.remove('is-gl');
          ctrl.hidden = true;
        }).finally(() => fig.classList.remove('is-carregando'));
      }, { rootMargin: '250px 0px' });
      vis.observaVer.observe(fig);
    }

    function desenhaVazio() {
      const box = q('[data-rast-vazio-mapa]');
      if (!box) return;
      const r = desenhaSvg(box, null, null, textos, { folga: { t: 0.08, r: 0.08, b: 0.08, l: 0.08 } });
      const m = marcaLoja(textos);
      m.classList.add('s-rast__no-svg', 's-rast__no-svg--pino');
      if (r.origemPx) {
        m.style.left = `${(r.origemPx.x / r.W) * 100}%`;
        m.style.top = `${(r.origemPx.y / r.H) * 100}%`;
        box.appendChild(m);
      }
    }

    function etapaDaUrl() {
      const v = semAcento(demoParam || '');
      return ['criado', 'postado', 'transito', 'saiu', 'entregue', 'problema', 'cancelado'].includes(v) ? v : 'transito';
    }

    // painel de antes da busca com o desenho do brasil, que acompanha a largura enquanto o painel aparece
    let roVazio = null;
    let larguraVazio = 0;
    function mostraVazio() {
      painel('vazio');
      const box = q('[data-rast-vazio-mapa]');
      if (box) box.textContent = '';
      desenhaVazio();
      larguraVazio = res.clientWidth;
      if (roVazio) return;
      roVazio = new ResizeObserver(() => {
        if (Math.abs(res.clientWidth - larguraVazio) < 2 || !q('[data-rast-painel="vazio"]') || q('[data-rast-painel="vazio"]').hidden) return;
        larguraVazio = res.clientWidth;
        q('[data-rast-vazio-mapa]').textContent = '';
        desenhaVazio();
      });
      roVazio.observe(res);
    }
    raiz.ntRastFim = () => {
      fechaMapa();
      if (roVazio) roVazio.disconnect();
    };

    trocaModo();
    const codigoBruto = String(params.get('codigo') || params.get('rastreio') || '').trim();
    const cpfUrl = pareceCpf(codigoBruto);
    const codigoUrl = cpfUrl ? '' : limpaCodigo(codigoBruto);
    // o link do e-mail traz o codigo no endereco: depois de lido ele sai dali (a envia mostra dados do comprador a
    // quem tiver o codigo, entao ele nao fica no historico, em link copiado nem no referer)
    if (params.has('codigo') || params.has('rastreio')) {
      try {
        const u = new URL(window.location.href);
        u.searchParams.delete('codigo');
        u.searchParams.delete('rastreio');
        window.history.replaceState(window.history.state, '', u);
      } catch (e) { /* sem history */ }
    }
    if (demo) {
      estado.etapaDemo = etapaDaUrl();
      const ci = q('[data-rast-campo="codigo"]');
      if (ci && codigoUrl) ci.value = codigoUrl;
      estado.resposta = normaliza(amostra(estado.etapaDemo, textos.origem, codigoUrl), { origem: textos.origem });
      mostra(false);
    } else if (codigoOk(codigoUrl)) {
      q('[data-rast-campo="codigo"]').value = codigoUrl;
      // link com ?codigo=: rola ate o resultado, mas o foco fica no comeco da pagina
      envia({ codigo: codigoUrl }, { foco: false });
    } else {
      mostraVazio();
      // link com codigo fora da regra: o aviso aparece no campo, sem puxar o foco
      if (codigoBruto) {
        const ci = q('[data-rast-campo="codigo"]');
        if (!cpfUrl) ci.value = codigoUrl;
        erroCampo(ci, cpfUrl ? ERRO_CAMPO.cpf : ERRO_CAMPO.codigo, false);
      }
    }
  }

  const tudo = (raiz) => (raiz || document).querySelectorAll('[data-rast]').forEach(iniciar);
  tudo();
  document.addEventListener('shopify:section:load', (e) => tudo(e.target));
  // no editor do tema a secao recarrega inteira: o mapa (webgl, laco de animacao e ouvintes) sai junto
  document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('[data-rast]').forEach((r) => { if (r.ntRastFim) r.ntRastFim(); }));
})();
